(function() {
  angular.module('oekoKostenrechner', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'rzModule', 'pascalprecht.translate', 'btford.markdown']);

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main.chart.table', {
      templateUrl: 'app/main/chart/table/table.html',
      controller: 'MainChartTableController',
      controllerAs: 'table'
    });
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').controller('MainChartTableController', function($translate) {
    'ngInject';
    var MainChartTableController;
    return new (MainChartTableController = (function() {
      function MainChartTableController() {}

      MainChartTableController.prototype.number = function(d) {
        var format;
        format = {
          de: 'formatDeDe',
          en: 'formatEnUs'
        };
        return d3_format[format[$translate.use()]].format(',')(d);
      };

      return MainChartTableController;

    })());
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').controller('MainVehicleController', function(vehicle, index, processor, DynamicInput, $scope, $uibModalInstance) {
    var MainVehicleController;
    return new (MainVehicleController = (function() {
      function MainVehicleController() {
        this.close = bind(this.close, this);
        this.saveVehicle = bind(this.saveVehicle, this);
        this.isGroupVisible = bind(this.isGroupVisible, this);
        this.isSettingVisible = bind(this.isSettingVisible, this);
        this.gs = bind(this.gs, this);
        var i, id, len, ref, ref1, s;
        this.contexts = ['vehicle'];
        this.vehicleRef = vehicle;
        this.vehicle = angular.copy(vehicle);
        this.index = index;
        this.changedFields = (ref = this.vehicle.changed_fields) != null ? ref : {};
        this.listedSettings = processor.getListedSettings();
        this.inputs = {};
        ref1 = processor.settings;
        for (i = 0, len = ref1.length; i < len; i++) {
          s = ref1[i];
          this.inputs[s.id] = new DynamicInput(s, this.vehicle);
        }
        this.values = {};
        for (id in this.inputs) {
          this.values[id] = this.inputs[id].getValues(this.vehicle);
        }
        this.groups = _.groupBy(this.listedSettings, 'group');
        this.groups = _.reduce(this.groups, function(res, settings, name) {
          res.push({
            name: name,
            settings: settings,
            importancerank: _.min(settings, 'importancerank').importancerank
          });
          return res;
        }, []);
      }

      MainVehicleController.prototype.gs = function(context, name, id) {
        return (function(_this) {
          return function(value) {
            var instance, values;
            if (value != null) {
              values = _this.values[id];
              if ((values.step != null) && parseInt(values.step) === values.step && !(value % values.step === 0)) {
                value = _this.vehicle[name];
              }
              _this.vehicle[name] = value;
              _this.changedFields[name] = true;
              if (name === 'energy_type' || name === 'car_type' || name === 'vehicle') {
                _this.changedFields = {};
              }
              if (name === 'energy_type' || name === 'car_type') {
                _this.vehicle.vehicle = void 0;
              }
              instance = _this;
              processor.calculateInputs(_this.vehicle, _this.changedFields).then(function() {
                var results;
                results = [];
                for (id in instance.inputs) {
                  results.push(instance.values[id] = instance.inputs[id].getValues(instance.vehicle));
                }
                return results;
              });
            }
            return _this.vehicle[name];
          };
        })(this);
      };

      MainVehicleController.prototype.isSettingVisible = function(setting) {
        if (setting.specifictoenergytype === null) {
          return true;
        }
        return _.map(setting.specifictoenergytype.split(','), _.trim).indexOf(this.vehicle.energy_type) > -1;
      };

      MainVehicleController.prototype.precision = function(interval) {
        var precision;
        if (interval === 0) {
          0;
        }
        precision = Math.ceil(-Math.log10(interval));
        if (precision > 0) {
          precision;
        }
        return 0;
      };

      MainVehicleController.prototype.isGroupVisible = function(group) {
        return _.some(group.settings, this.isSettingVisible);
      };

      MainVehicleController.prototype.saveVehicle = function() {
        var instance;
        instance = this;
        return processor.calculateResults(this.vehicle, this.changedFields).then(function(vehicle) {
          angular.extend(instance.vehicleRef, vehicle);
          return instance.close();
        });
      };

      MainVehicleController.prototype.close = function() {
        return $uibModalInstance.close(this.vehicle);
      };

      return MainVehicleController;

    })());
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main.permalink', {
      url: 'permalink?vehicles',
      controller: 'MainPermalinkController',
      controllerAs: 'permalink'
    });
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').controller('MainPermalinkController', function($state, $stateParams, $scope) {
    'ngInject';
    var MainPermalinkController;
    return new (MainPermalinkController = (function() {
      function MainPermalinkController() {
        var data, dataJson, dataObj, i, len, vehicle, vehicles;
        data = $stateParams.vehicles;
        dataJson = window.atob(data);
        dataObj = angular.fromJson(dataJson);
        vehicles = dataObj.splice(0, 2);
        $scope.$parent.main.vehicles = [];
        for (i = 0, len = vehicles.length; i < len; i++) {
          vehicle = vehicles[i];
          $scope.$parent.main.addVehicle(vehicle);
        }
        $state.go('main.chart');
      }

      return MainPermalinkController;

    })());
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main.page', {
      templateUrl: 'app/main/page/page.html',
      controller: 'MainPageController',
      controllerAs: 'page',
      url: 'page/:slug',
      params: {
        language: {
          value: null
        }
      },
      resolve: {
        content: function($stateParams, $http, $translate) {
          'ngInject';
          var path;
          path = ['assets/markdowns', $stateParams.slug, ($stateParams.language || $translate.proposedLanguage() || $translate.use()) + '.md'].join('/');
          return $http.get(path).then(function(res) {
            return res.data;
          });
        }
      }
    });
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').controller('MainPageController', function(content, $state, $rootScope) {
    'ngInject';
    var MainPageController;
    return new (MainPageController = (function() {
      function MainPageController() {
        this.content = content;
        $rootScope.$on('$translateChangeSuccess', function(ev, use) {
          if ($state.current.name === 'main.page') {
            return $state.go('main.page', use, {
              reload: false
            });
          }
        });
      }

      return MainPageController;

    })());
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main.form', {
      templateUrl: 'app/main/form/form.html',
      controller: 'MainFormController',
      controllerAs: 'form',
      url: 'add'
    });
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').controller('MainFormController', function($scope, $timeout, $state, $translate, processor, DynamicInput) {
    'ngInject';
    var MainFormController;
    return new (MainFormController = (function() {
      function MainFormController() {
        this.previousStep = bind(this.previousStep, this);
        this.nextStep = bind(this.nextStep, this);
        this.hasPreviousStep = bind(this.hasPreviousStep, this);
        this.hasNextStep = bind(this.hasNextStep, this);
        this.setActiveStepIdx = bind(this.setActiveStepIdx, this);
        this.getActiveStepIdx = bind(this.getActiveStepIdx, this);
        this.getActiveStep = bind(this.getActiveStep, this);
        this.getStepValues = bind(this.getStepValues, this);
        this.getStepType = bind(this.getStepType, this);
        this.isStepActive = bind(this.isStepActive, this);
        this.getStepsCount = bind(this.getStepsCount, this);
        this.addVehicle = bind(this.addVehicle, this);
        this.refreshStep = bind(this.refreshStep, this);
        this.newVehicle = {};
        this.values = {};
        this.inputs = {};
        this.setActiveStepIdx(0);
      }

      MainFormController.prototype.refreshStep = function() {
        var i, id, len, ref, s;
        ref = processor.settings;
        for (i = 0, len = ref.length; i < len; i++) {
          s = ref[i];
          this.inputs[s.id] = new DynamicInput(s);
        }
        for (id in this.inputs) {
          this.values[id] = this.inputs[id].getValues(this.newVehicle);
        }
        return $timeout((function() {
          return $scope.$broadcast('reCalcViewDimensions');
        }), 300);
      };

      MainFormController.prototype.addVehicle = function() {
        $scope.$parent.main.setVehicleCompare(this.newVehicle);
        this.newVehicle = {};
        this.setActiveStepIdx(0);
        return $state.go('main.chart');
      };

      MainFormController.prototype.getStepsCount = function() {
        return this.getSteps().length;
      };

      MainFormController.prototype.getSteps = function() {
        if (this.steps != null) {
          return this.steps;
        }
        return this.steps = processor.getPreliminarySettings();
      };

      MainFormController.prototype.isStepActive = function(step, index) {
        return index === this.getActiveStepIdx() && (this.values[step.id] != null);
      };

      MainFormController.prototype.getStepType = function(step) {
        return this.inputs[step.id].getType();
      };

      MainFormController.prototype.getStepValues = function(step) {
        return _.extend(this.values[step.id], {
          translate: function(v) {
            return v + ' ' + $translate.instant(step.unit);
          }
        });
      };

      MainFormController.prototype.getActiveStep = function() {
        return this.getSteps()[this.activeStepIdx];
      };

      MainFormController.prototype.getActiveStepIdx = function() {
        return this.activeStepIdx;
      };

      MainFormController.prototype.setActiveStepIdx = function(idx) {
        this.activeStepIdx = idx;
        return this.refreshStep();
      };

      MainFormController.prototype.hasNextStep = function() {
        return this.activeStepIdx < this.getStepsCount() - 1;
      };

      MainFormController.prototype.hasPreviousStep = function() {
        return this.activeStepIdx > 0;
      };

      MainFormController.prototype.nextStep = function() {
        if (this.hasNextStep()) {
          return this.setActiveStepIdx(this.activeStepIdx + 1);
        } else {
          return this.addVehicle();
        }
      };

      MainFormController.prototype.previousStep = function() {
        if (!this.hasPreviousStep()) {
          return $state.go('main');
        } else {
          return this.setActiveStepIdx(this.activeStepIdx - 1);
        }
      };

      return MainFormController;

    })());
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main.chart', {
      templateUrl: 'app/main/chart/chart.html',
      controller: 'MainChartController',
      controllerAs: 'chart'
    }).state('main.chart.tco', {
      params: {
        type: {
          value: 'bar'
        }
      }
    }).state('main.chart.co2', {
      params: {
        type: {
          value: 'spline'
        }
      }
    });
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').directive('chart', function(DynamicInput, MAIN, $translate) {
    'ngInject';
    return {
      restrict: 'EA',
      scope: {
        x: "=",
        y: "=",
        vehicles: "=",
        type: "=",
        processor: "="
      },
      link: function(scope, element, attr) {
        var Chart;
        return new (Chart = (function() {
          Chart.prototype.TRANSITION_DURATION = 600;

          Chart.prototype.DEFAULT_CONFIG = c3.chart.internal.fn.getDefaultConfig();

          Chart.prototype.bindWatchers = function() {
            scope.$watch('[x, y, vehicles, type]', this.updateChart, true);
            return scope.$watch((function() {
              return $translate.use();
            }), this.updateChart);
          };

          Chart.prototype.updateChart = function() {
            var cols, toUnload;
            cols = this.generateColumns();
            toUnload = _.difference(_.map(this.chart.data(), 'id'), _.map(cols, 0));
            this.chart.load({
              type: scope.type,
              columns: cols,
              colors: this.generateColors(),
              unload: toUnload,
              done: this.enhanceChart,
              categories: _.map(this.getXValues(), this.formatTick)
            });
            this.chart.axis.labels({
              y: this.generateYAxis(cols).label.text
            });
            this.chart.axis.min({
              y: this.generateYAxis(cols).min
            });
            this.chart.groups(this.generateGroups(cols));
            return this.chart.legend[this.hasLegend() ? 'show' : 'hide']();
          };

          Chart.prototype.getMinBarY = function(cols) {
            var col, i, j, k, len, ref, values;
            values = [0, 0];
            ref = cols.slice(1);
            for (j = 0, len = ref.length; j < len; j++) {
              col = ref[j];
              for (i = k = 1; k <= 2; i = ++k) {
                if (col[i] < 0) {
                  values[i - 1] += col[i];
                }
              }
            }
            return _.min(values);
          };

          Chart.prototype.getTooltipContents = function() {
            if (scope.type !== 'bar') {
              if (scope.y === 'TCO') {
                arguments[0] = _.chain(arguments[0]).filter(function(datum) {
                  return datum.id.indexOf('-mittel') > -1;
                }).each((function(_this) {
                  return function(datum) {
                    var id, vehicle;
                    id = datum.id.replace('-mittel', '');
                    vehicle = _.find(scope.vehicles, {
                      id: id
                    });
                    return datum.name = _this.getVehicleTranslation(vehicle);
                  };
                })(this)).value();
              } else if (scope.y === 'CO2') {
                arguments[0] = _.chain(arguments[0]).each((function(_this) {
                  return function(datum) {
                    var id, vehicle;
                    id = datum.id.replace('vehicle-', '');
                    vehicle = _.find(scope.vehicles, {
                      id: id
                    });
                    return datum.name = _this.getVehicleTranslation(vehicle);
                  };
                })(this)).value();
              }
            }
            return c3.chart.internal.fn.getTooltipContent.apply(this.chart.internal, arguments);
          };

          Chart.prototype.getVehicleDisplay = function(vehicle) {
            var display;
            if (scope.type === 'bar') {
              return vehicle.TCO_simplified;
            } else {
              display = scope.processor.findDisplay({
                xaxis: scope.x,
                yaxis: scope.y
              });
              if (display != null) {
                return vehicle[display.name];
              } else {
                return [];
              }
            }
          };

          Chart.prototype.getVehicleTranslation = function(vehicle) {
            return $translate.instant("vehicle_name_striped", {
              energy_type: $translate.instant(vehicle.energy_type),
              car_type: $translate.instant(vehicle.car_type)
            });
          };

          Chart.prototype.getXValues = function() {
            var input, setting, values, valuesWithId, vehicle;
            if (scope.type === 'bar') {
              values = (function() {
                var j, len, ref, results;
                ref = scope.vehicles;
                results = [];
                for (j = 0, len = ref.length; j < len; j++) {
                  vehicle = ref[j];
                  results.push(this.getVehicleTranslation(vehicle));
                }
                return results;
              }).call(this);
              valuesWithId = angular.copy(values);
              angular.forEach(values, function(value, i) {
                var count, previous;
                count = _.filter(values, function(v) {
                  return v === value;
                }).length;
                if (count > 1) {
                  previous = _.filter(values.slice(0, i), function(v) {
                    return v === value;
                  }).length;
                  return valuesWithId[i] = value + ' (' + previous + ')';
                }
              });
              return valuesWithId;
            } else {
              setting = scope.processor.getSettingsBy({
                name: scope.x
              })[0];
              input = new DynamicInput(setting);
              return input.getValues().range;
            }
          };

          Chart.prototype.getVehicleValues = function(vehicle, component) {
            var display;
            display = this.getVehicleDisplay(vehicle);
            if (component != null) {
              return display[component] || [];
            } else {
              return display.y_values;
            }
          };

          Chart.prototype.getRefYear = function() {
            var countByYear, displays, refYear, vehicle, year, years;
            refYear = null;
            displays = (function() {
              var j, len, ref, results;
              ref = scope.vehicles;
              results = [];
              for (j = 0, len = ref.length; j < len; j++) {
                vehicle = ref[j];
                results.push(this.getVehicleDisplay(vehicle));
              }
              return results;
            }).call(this);
            years = _.concat.apply(null, _.chain(displays).map('mittel').map(_.keys).value());
            countByYear = _.chain(years).map(Number).sort().countBy().value();
            for (year in countByYear) {
              if (countByYear[year] === scope.vehicles.length) {
                refYear = year;
                break;
              }
            }
            return refYear;
          };

          Chart.prototype.generateColumns = function() {
            var component, display, fn, j, k, l, len, len1, len2, n, order, ref, ref1, ref2, refYear, series, values, vehicle;
            series = [_.concat(['x'], this.getXValues())];
            if (scope.type === 'spline') {
              ref = scope.vehicles;
              for (j = 0, len = ref.length; j < len; j++) {
                vehicle = ref[j];
                if (scope.y === 'TCO') {
                  ref1 = ['contra', 'pro', 'mittel'];
                  for (k = 0, len1 = ref1.length; k < len1; k++) {
                    component = ref1[k];
                    values = this.getVehicleValues(vehicle, component);
                    series.push(_.concat([vehicle.id + '-' + component], values));
                  }
                } else {
                  values = this.getVehicleValues(vehicle);
                  series.push(_.concat(['vehicle-' + vehicle.id], values));
                }
              }
            } else {
              refYear = this.getRefYear();
              values = {};
              ref2 = scope.vehicles;
              for (l = 0, len2 = ref2.length; l < len2; l++) {
                vehicle = ref2[l];
                if (display = this.getVehicleDisplay(vehicle)) {
                  fn = function(obj) {
                    var n, results;
                    results = [];
                    for (n in obj) {
                      if (n.indexOf('total') === 0) {
                        continue;
                      }
                      if (typeof obj[n] !== 'object') {
                        if (values[n] == null) {
                          values[n] = [];
                        }
                        results.push(values[n].push(obj[n]));
                      } else {
                        results.push(fn(obj[n]));
                      }
                    }
                    return results;
                  };
                  fn(display);
                }
              }
              series = series.concat((function() {
                var results;
                results = [];
                for (n in values) {
                  results.push(_.concat([n], values[n]));
                }
                return results;
              })());
              order = ['x', 'net_cost', 'charging_infrastructure', 'fixed_costs', 'variable_costs', 'energy_costs'];
              series = _.sortBy(series, function(s) {
                return order.indexOf(s[0]);
              });
              series = _.each(series, function(s) {
                return s[0] = $translate.instant(s[0]);
              });
            }
            return series;
          };

          Chart.prototype.formatTick = function(d) {
            if (scope.x === 'holding_time' || scope.type === 'bar') {
              return d;
            } else {
              return this.formatNumber(d);
            }
          };

          Chart.prototype.formatNumber = function(d) {
            var format;
            format = {
              de: 'formatDeDe',
              en: 'formatEnUs'
            };
            return d3_format[format[$translate.use()]].format(',')(d);
          };

          Chart.prototype.generateXAxis = function(cols) {
            return {
              type: 'categories',
              categories: this.getXValues(),
              tick: {
                outer: false,
                centered: true,
                culling: {
                  max: 10
                },
                multiline: false
              }
            };
          };

          Chart.prototype.generateYAxis = function(cols) {
            return {
              tick: {
                format: this.formatNumber
              },
              min: scope.type === 'bar' ? this.getMinBarY(cols) : 0,
              padding: {
                bottom: 0
              },
              label: {
                position: 'outer-middle',
                text: $translate.instant(scope.y === 'CO2' ? 'kg_unit' : 'cost_unit')
              }
            };
          };

          Chart.prototype.generateColors = function(cols) {
            var c, colors, idx, j, k, key, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, v;
            colors = {};
            if (scope.y === 'CO2') {
              ref = scope.vehicles;
              for (j = 0, len = ref.length; j < len; j++) {
                v = ref[j];
                colors['vehicle-' + v.id] = v.color;
              }
            } else if (scope.y === 'TCO' && scope.type === 'spline') {
              ref1 = scope.vehicles;
              for (k = 0, len1 = ref1.length; k < len1; k++) {
                v = ref1[k];
                ref2 = ['contra', 'pro'];
                for (l = 0, len2 = ref2.length; l < len2; l++) {
                  c = ref2[l];
                  colors[v.id + '-' + c] = v.color;
                }
                colors[v.id + '-mittel'] = d3.rgb(v.color).toString();
              }
            } else {
              if (cols == null) {
                cols = this.generateColumns();
              }
              cols = angular.copy(cols);
              ref3 = _.map(cols.splice(1), 0);
              for (idx = m = 0, len3 = ref3.length; m < len3; idx = ++m) {
                key = ref3[idx];
                colors[key] = MAIN.COLORS[idx % MAIN.COLORS.length];
              }
            }
            return colors;
          };

          Chart.prototype.generateGroups = function(cols) {
            if (scope.type === 'bar') {
              if (cols == null) {
                cols = this.generateColumns();
              }
              cols = angular.copy(cols);
              return [_.map(cols.splice(1), 0)];
            } else {
              return [];
            }
          };

          Chart.prototype.generateTooltip = function() {
            return {
              show: true,
              format: {
                name: function(v) {
                  return $translate.instant(v);
                },
                value: (function(_this) {
                  return function(v) {
                    var units;
                    units = {
                      TCO: '€',
                      CO2: ' t CO₂'
                    };
                    return _this.formatNumber(v) + units[scope.y];
                  };
                })(this)
              },
              contents: this.getTooltipContents,
              position: (function(_this) {
                return function(data, width) {
                  var maxLeft;
                  maxLeft = element.width() - width;
                  return {
                    top: 0,
                    left: Math.min(_this.chart.internal.x(data[0].x), maxLeft)
                  };
                };
              })(this)
            };
          };

          Chart.prototype.getLabelsFormat = function(v, id) {
            if (!/\d/.test(id) && v > 0) {
              return v;
            }
          };

          Chart.prototype.getYForText = function(fn) {
            return function(points, d, textElement) {
              var box, ypos;
              if (scope.type === 'bar') {
                box = textElement.getBoundingClientRect();
                ypos = points[0][1] + (points[1][1] - points[0][1]) / 2;
                return ypos += box.height * 0.3;
              } else {
                return fn.call(this, points, d, textElement);
              }
            };
          };

          Chart.prototype.hasLegend = function() {
            return scope.type === 'bar';
          };

          Chart.prototype.hasTooltip = function() {
            return scope.type !== 'bar';
          };

          Chart.prototype.generateChart = function() {
            var columns;
            columns = this.generateColumns();
            window.c = this.chart = c3.generate({
              onrendered: this.enhanceChart,
              bindto: element[0],
              size: {
                height: 400
              },
              interaction: {
                enabled: true
              },
              padding: {
                top: 20
              },
              legend: {
                position: 'right',
                show: this.hasLegend()
              },
              point: {
                show: false
              },
              line: {
                connectNull: true
              },
              transition: {
                duration: this.TRANSITION_DURATION
              },
              axis: {
                x: this.generateXAxis(columns),
                y: this.generateYAxis(columns)
              },
              grid: {
                y: {
                  show: true
                }
              },
              tooltip: this.generateTooltip(),
              data: {
                labels: {
                  format: this.getLabelsFormat
                },
                selection: {
                  enabled: false
                },
                x: 'x',
                type: scope.type,
                columns: columns,
                order: null,
                colors: this.generateColors(columns),
                groups: this.generateGroups(columns)
              }
            });
            return this.chart.internal.getYForText = this.getYForText(this.chart.internal.getYForText);
          };

          Chart.prototype.setupAreas = function() {
            if ((this.svg == null) || (this.areasGroup == null)) {
              this.svg = d3.select(element[0]).select('svg');
              return this.areasGroup = this.svg.select('.c3-chart').insert('g', '.c3-chart-lines').attr('class', 'd3-chart-areas');
            }
          };

          Chart.prototype.getArea = function() {
            return d3.svg.area().x((function(_this) {
              return function(d) {
                return _this.chart.internal.x(d.x);
              };
            })(this)).y0((function(_this) {
              return function(d) {
                return _this.chart.internal.y(d.pro);
              };
            })(this)).y1((function(_this) {
              return function(d) {
                return _this.chart.internal.y(d.contra);
              };
            })(this));
          };

          Chart.prototype.enhanceChart = function() {
            var areas, vehicles;
            if (this.chart == null) {
              return;
            }
            this.setupAreas();
            vehicles = scope.type === 'spline' && scope.y === 'TCO' ? scope.vehicles : [];
            areas = this.areasGroup.selectAll('path.d3-chart-area').data(vehicles);
            areas.enter().append('path').attr('class', function(d) {
              return 'd3-chart-area d3-chart-area-' + d.id;
            });
            areas.datum((function(_this) {
              return function(d) {
                var contra, datum, i, pro, ref, ref1;
                datum = [];
                pro = (ref = (_this.chart.data(d.id + "-pro"))[0]) != null ? ref.values : void 0;
                contra = (ref1 = (_this.chart.data(d.id + "-contra"))[0]) != null ? ref1.values : void 0;
                for (i in pro) {
                  if (pro[i].value != null) {
                    datum.push({
                      pro: pro[i].value,
                      contra: contra[i].value,
                      x: pro[i].x
                    });
                  }
                }
                return datum;
              };
            })(this)).style({
              fill: function(d, i) {
                return vehicles[i].color;
              },
              opacity: 1
            });
            areas.transition().duration(this.TRANSITION_DURATION).attr('d', this.getArea());
            return areas.exit().transition().duration(this.TRANSITION_DURATION).style('opacity', 0).remove();
          };

          function Chart() {
            this.enhanceChart = bind(this.enhanceChart, this);
            this.getArea = bind(this.getArea, this);
            this.setupAreas = bind(this.setupAreas, this);
            this.generateChart = bind(this.generateChart, this);
            this.generateTooltip = bind(this.generateTooltip, this);
            this.generateGroups = bind(this.generateGroups, this);
            this.generateColors = bind(this.generateColors, this);
            this.generateYAxis = bind(this.generateYAxis, this);
            this.generateXAxis = bind(this.generateXAxis, this);
            this.formatTick = bind(this.formatTick, this);
            this.generateColumns = bind(this.generateColumns, this);
            this.getRefYear = bind(this.getRefYear, this);
            this.getVehicleValues = bind(this.getVehicleValues, this);
            this.getXValues = bind(this.getXValues, this);
            this.getTooltipContents = bind(this.getTooltipContents, this);
            this.updateChart = bind(this.updateChart, this);
            this.bindWatchers();
            this.generateChart();
          }

          return Chart;

        })());
      }
    };
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').controller('MainChartController', function($scope, $state, $http, $window, processor, MAIN) {
    'ngInject';
    var MainChartController;
    return new (MainChartController = (function() {
      function MainChartController() {
        this.generateShortPermalink = bind(this.generateShortPermalink, this);
        this.getSimplifiedVehicles = bind(this.getSimplifiedVehicles, this);
        this.getJsonVehicles = bind(this.getJsonVehicles, this);
        $scope.$on('$stateChangeSuccess', (function(_this) {
          return function() {
            var i, len, option, ref, results;
            _this.type = $state.params.type || MAIN.CHART_TYPE;
            _this.yAxis = $state.is('main.chart.co2') ? 'CO2' : MAIN.CHART_YAXIS;
            if (_this.xAxis === 'co2_price' && _this.yAxis === 'CO2') {
              _this.xAxis = MAIN.CHART_XAXIS;
            }
            if (_this.yAxis === 'CO2') {
              _this.xAxisOptions = [];
              ref = processor.getXAxisSettings();
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                option = ref[i];
                if (option.name !== 'co2_price') {
                  results.push(_this.xAxisOptions.push(option));
                } else {
                  results.push(void 0);
                }
              }
              return results;
            } else {
              return _this.xAxisOptions = processor.getXAxisSettings();
            }
          };
        })(this));
        this.vehicles = $scope.$parent.main.vehicles;
        this.type = MAIN.CHART_TYPE;
        this.xAxisOptions = processor.getXAxisSettings();
        this.xAxis = MAIN.CHART_XAXIS;
        this.yAxis = MAIN.CHART_YAXIS;
        $state.go('main.chart.tco', {
          type: 'bar'
        });
        $scope.$watch('chart.vehicles', this.generateShortPermalink, true);
      }

      MainChartController.prototype.print = function() {
        return $window.print();
      };

      MainChartController.prototype.getXYears = function() {
        var i, ref, ref1, results, y;
        results = [];
        for (y = i = ref = MAIN.FLOOR_YEAR, ref1 = MAIN.CEIL_YEAR; ref <= ref1 ? i <= ref1 : i >= ref1; y = ref <= ref1 ? ++i : --i) {
          results.push(y);
        }
        return results;
      };

      MainChartController.prototype.getExplainer = function() {
        var display;
        if (this.type === 'bar') {
          return 'expl5';
        }
        display = processor.findDisplay({
          xaxis: this.xAxis,
          yaxis: this.yAxis
        });
        return display != null ? display.explainer : void 0;
      };

      MainChartController.prototype.getPermalink = function() {
        var link;
        link = $state.href('main.permalink', {
          vehicles: window.btoa(this.getJsonVehicles())
        }, {
          absolute: true
        });
        return link;
      };

      MainChartController.prototype.getJsonVehicles = function() {
        return angular.toJson(this.getSimplifiedVehicles());
      };

      MainChartController.prototype.getSimplifiedVehicles = function() {
        var exported, i, len, ref, vehicle;
        exported = [];
        ref = this.vehicles;
        for (i = 0, len = ref.length; i < len; i++) {
          vehicle = ref[i];
          exported.push(processor.exportVehicle(vehicle));
        }
        return exported;
      };

      MainChartController.prototype.generateShortPermalink = function() {
        var config;
        config = {
          cache: true,
          params: {
            url: this.getPermalink()
          }
        };
        return this.permalink = config.params.url;
      };

      return MainChartController;

    })());
  });

}).call(this);



(function() {
  angular.module("oekoKostenrechner").animation(".slide", function() {
    return {
      beforeAddClass: function(element, className, done) {
        if (className === "ng-hide") {
          jQuery(element).show().slideUp(600, done);
        }
        return null;
      },
      removeClass: function(element, className, done) {
        if (className === "ng-hide") {
          jQuery(element).hide().slideDown(600, done);
        }
        return null;
      }
    };
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').directive('selectOnClick', function($window) {
    'ngInject';
    return {
      restrict: 'A',
      link: function(scope, element) {
        return element.on('click', function() {
          if (!$window.getSelection().toString()) {
            return this.setSelectionRange(0, this.value.length);
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').service('vehicledata', function($http) {
    return {
      getVehicleDataByUuid: function(uuid) {
        return $http.get('assets/vehicledata/' + uuid + '.json');
      }
    };
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').service('Processor', function(vehicledata) {
    var Processor;
    return Processor = (function() {
      Processor.prototype.vehicles = [];

      function Processor(settings, display, vehicleData) {
        this.settings = settings;
        this.display = display;
        this.vehicleData = vehicleData;
        this.findDisplay = bind(this.findDisplay, this);
        this.getXAxisSettings = bind(this.getXAxisSettings, this);
        this.getListedSettings = bind(this.getListedSettings, this);
        this.getPreliminarySettings = bind(this.getPreliminarySettings, this);
        this.getSettingsNames = bind(this.getSettingsNames, this);
        this.getSettingsBy = bind(this.getSettingsBy, this);
      }

      Processor.prototype.getSettingsBy = function(filter) {
        return _(this.settings).filter(filter).sortBy('importancerank').value();
      };

      Processor.prototype.getSettingsNames = function() {
        return _.map(this.settings, 'name');
      };

      Processor.prototype.getPreliminarySettings = function() {
        return this.getSettingsBy({
          preliminary: true
        });
      };

      Processor.prototype.getListedSettings = function() {
        return this.getSettingsBy({
          shownonthelist: true,
          privatvisible: true
        });
      };

      Processor.prototype.getXAxisSettings = function() {
        return this.getSettingsBy({
          canbeonxaxis: true
        });
      };

      Processor.prototype.findDisplay = function(query) {
        return _.find(this.display, query);
      };

      Processor.prototype.calculateInputs = function(vehicle, allChangedFields) {
        var facade;
        facade = new Facade(this.vehicleData, vehicledata);
        return facade.calculateInputs(vehicle, allChangedFields);
      };

      Processor.prototype.calculateResults = function(vehicle, allChangedFields) {
        var facade;
        facade = new Facade(this.vehicleData, vehicledata);
        return facade.calculateResults(vehicle, allChangedFields);
      };

      Processor.prototype.exportVehicle = function(vehicle) {
        var facade;
        facade = new Facade(this.vehicleData, vehicledata);
        return facade.exportVehicle(vehicle, vehicle.changed_fields);
      };

      Processor.prototype.testVehicleDetails = function() {
        var facade;
        facade = new Facade(this.vehicleData, vehicledata);
        return facade.testVehicleDetail();
      };

      return Processor;

    })();
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').directive('navbar', function() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: 'NavbarController'
    };
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').controller('NavbarController', function() {});

}).call(this);



(function() {
  angular.module('oekoKostenrechner').directive("formChange", function($parse) {
    return {
      restrict: 'A',
      require: "form",
      priority: -1,
      link: function(scope, element, attrs) {
        var cb;
        cb = $parse(attrs.formChange);
        return element.on("change", function(ev) {
          return scope.$apply(function() {
            var modelElm, modelExp, newScope;
            newScope = scope.$new();
            modelElm = angular.element(ev.target);
            modelExp = modelElm.attr('form-change-model');
            newScope.$value = modelExp != null ? $parse(modelExp)(modelElm.scope()) : null;
            return cb(newScope);
          });
        });
      }
    };
  }).directive("formChangeModel", function($parse) {
    return {
      restrict: 'A',
      priority: 1000,
      require: "^^formChange"
    };
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').service('DynamicInput', function(DYNAMIC_INPUT) {
    var DynamicInput;
    return DynamicInput = (function() {
      var FIELD_BOOLEAN, FIELD_ENUM, FIELD_INTERVAL;

      FIELD_INTERVAL = /(-?\w+)\.\.(-?\w+)/;

      FIELD_ENUM = /,\w?/g;

      FIELD_BOOLEAN = /boolean/;

      function DynamicInput(setting, subset) {
        this.getType = bind(this.getType, this);
        this.getValues = bind(this.getValues, this);
        this.setSubset = bind(this.setSubset, this);
        this.setSetting = bind(this.setSetting, this);
        this.setSetting(setting);
        this.setSubset(subset);
      }

      DynamicInput.prototype.setSetting = function(setting) {
        return this.setting = setting;
      };

      DynamicInput.prototype.setSubset = function(subset) {
        if (subset == null) {
          subset = {};
        }
        return this.subset = subset;
      };

      DynamicInput.prototype.getValues = function(subset) {
        var EXCEPTION, all, ceil, floor, i, len, range, ref, ref1, step;
        if (subset == null) {
          subset = this.subset;
        }
        switch (this.getType()) {
          case DYNAMIC_INPUT.FIELD_INTERVAL:
            step = 1 * this.setting.interval || 1;
            ref = this.setting.values.match(FIELD_INTERVAL), all = ref[0], floor = ref[1], ceil = ref[2];
            floor = isNaN(floor) ? 1 * subset[floor] || 0 : 1 * floor;
            ceil = isNaN(ceil) ? 1 * subset[ceil] || 10 : 1 * ceil;
            return {
              floor: floor,
              ceil: ceil,
              step: step,
              value: this.setting["default"] || (floor + ceil) / 2,
              range: _.range(floor, ceil + step, step)
            };
          case DYNAMIC_INPUT.FIELD_ENUM:
            range = _.map(this.setting.values.split(','), function(v) {
              return _.trim(v, ' "');
            });
            ref1 = DYNAMIC_INPUT.EXCEPTIONS;
            for (i = 0, len = ref1.length; i < len; i++) {
              EXCEPTION = ref1[i];
              if (EXCEPTION.TO === this.setting.name) {
                if (EXCEPTION.INCLUDE.indexOf(subset[EXCEPTION.IF]) > -1) {
                  range = range.concat(EXCEPTION.ADD);
                }
              }
            }
            return {
              range: range
            };
          case DYNAMIC_INPUT.FIELD_BOOLEAN:
            return {
              range: [true, false]
            };
          case DYNAMIC_INPUT.FIElD_ENUM_DYNAMIC:
            return {
              range: subset[this.setting.vehicle_values]
            };
        }
      };

      DynamicInput.prototype.getType = function() {
        switch (true) {
          case !this.setting.editable:
            return DYNAMIC_INPUT.FIELD_STATIC;
          case !!this.setting.vehicle_values:
            return DYNAMIC_INPUT.FIElD_ENUM_DYNAMIC;
          case this.setting.hasslider || (this.setting.values.match(FIELD_INTERVAL) != null):
            return DYNAMIC_INPUT.FIELD_INTERVAL;
          case this.setting.values.match(FIELD_ENUM) != null:
            return DYNAMIC_INPUT.FIELD_ENUM;
          case this.setting.values.match(FIELD_BOOLEAN) != null:
            return DYNAMIC_INPUT.FIELD_BOOLEAN;
        }
      };

      return DynamicInput;

    })();
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').constant('DYNAMIC_INPUT', {
    FIELD_INTERVAL: 'interval',
    FIELD_ENUM: 'enum',
    FIELD_BOOLEAN: 'boolean',
    FIELD_STATIC: 'static',
    FIElD_ENUM_DYNAMIC: 'enum_dynamic',
    EXCEPTIONS: []
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider) {
    return $stateProvider.state('main', {
      url: '/',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main',
      resolve: {
        language: function($translate) {
          return $translate.onReady();
        },
        settings: function($http) {
          return $http.get('assets/settings.json');
        },
        display: function($http) {
          return $http.get('assets/display.json');
        },
        vehicles: function($http) {
          return $http.get('assets/vehiclelist.json');
        },
        processor: function(settings, display, vehicles, Processor) {
          return new Processor(settings.data, display.data, vehicles.data);
        }
      }
    });
  });

}).call(this);



(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  angular.module('oekoKostenrechner').controller('MainController', function($state, $translate, $uibModal, processor, MAIN) {
    'ngInject';
    var MainController;
    return new (MainController = (function() {
      function MainController() {
        this.addVehicle = bind(this.addVehicle, this);
        this.setVehicleCompare = bind(this.setVehicleCompare, this);
        this.removeVehicle = bind(this.removeVehicle, this);
        this.filterSetting = bind(this.filterSetting, this);
        var main;
        this.processor = processor;
        this.listedSettings = processor.getListedSettings();
        this.vehicles = processor.vehicles;
        this.showTour = true;
        this.vehicleData = {};
        main = this;
      }

      MainController.prototype.use = $translate.use;

      MainController.prototype.openVehicle = function(vehicle, index) {
        return this.vehicleModal = $uibModal.open({
          animation: false,
          size: 'lg',
          templateUrl: 'app/main/vehicle/vehicle.html',
          controller: 'MainVehicleController',
          controllerAs: 'modal',
          resolve: {
            vehicle: function() {
              return vehicle;
            },
            index: function() {
              return index;
            },
            processor: function() {
              return processor;
            }
          }
        });
      };

      MainController.prototype.hasNoParent = function(setting) {
        return setting.parentid === null || isNaN(setting.parentid);
      };

      MainController.prototype.filterSetting = function(vehicle) {
        return (function(_this) {
          return function(setting) {
            return (setting.specifictoenergytype === null || _.map(setting.specifictoenergytype.split(','), _.trim).indexOf(vehicle.energy_type) > -1) && (vehicle[setting.name] != null) && _this.hasNoParent(setting && setting.context === 'vehicle');
          };
        })(this);
      };

      MainController.prototype.removeVehicle = function(index) {
        return this.vehicles.splice(index, 1);
      };

      MainController.prototype.getVehicleColor = function(n) {
        return MAIN.COLORS[(n - 1) % MAIN.COLORS.length];
      };

      MainController.prototype.getVehicleOpts = function(vehicle) {
        return {
          energy_type: $translate.instant(vehicle.energy_type),
          car_type: $translate.instant(vehicle.car_type)
        };
      };

      MainController.prototype.setVehicleCompare = function(params) {
        var compare, main;
        compare = angular.copy(params);
        if (this.vehicles.length === 2) {
          this.vehicles.length = 0;
        }
        main = this;
        return this.addVehicle(params).then(function() {
          if (main.vehicles.length === 1) {
            compare.energy_type = "bev";
            return main.addVehicle(compare);
          }
        });
      };

      MainController.prototype.addVehicle = function(params) {
        var color, field, id, locked, main;
        id = _.uniqueId();
        color = this.getVehicleColor(id);
        params.id = id;
        params.color = color;
        locked = {};
        for (field in params) {
          locked[field] = true;
        }
        main = this;
        return main.processor.calculateInputs(params, locked).then(function() {
          return main.processor.calculateResults(params, locked).then(function() {
            return main.vehicles.push(params);
          });
        });
      };

      MainController.prototype.addDefault = function(energyType, carType) {
        this.setVehicleCompare({
          energy_type: energyType,
          car_type: carType,
          mileage: 15000,
          acquisition_year: 2026
        });
        return $state.go('main.chart');
      };

      return MainController;

    })());
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').constant('MAIN', {
    SHORTENER_INTERFACE: '//white-shortener.herokuapp.com',
    SHORTENER_PROVIDER: 'goo.gl',
    CHART_TYPE: 'bar',
    CHART_YAXIS: 'TCO',
    CHART_XAXIS: 'mileage',
    FLOOR_YEAR: 2024,
    CEIL_YEAR: 2030,
    COLORS: (function() {
      var base, c, colors, i, j, k, len, len1, len2;
      base = ["#71BF44", "#00B7DD", "#9245bf", "#bf5545", "#ffcc00"];
      colors = [];
      for (i = 0, len = base.length; i < len; i++) {
        c = base[i];
        colors.push(c);
      }
      for (j = 0, len1 = base.length; j < len1; j++) {
        c = base[j];
        colors.push(d3.rgb(c).darker(1).toString());
      }
      for (k = 0, len2 = base.length; k < len2; k++) {
        c = base[k];
        colors.push(d3.rgb(c).darker(2).toString());
      }
      return colors;
    })()
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($translateProvider) {
    'ngInject';
    return $translateProvider.useStaticFilesLoader({
      prefix: 'assets/locales/',
      suffix: '.json'
    }).registerAvailableLanguageKeys(['de', 'en'], {
      'de_DE': 'de',
      'en_US': 'en',
      'en_UK': 'en',
      'en-US': 'en',
      'en-UK': 'en'
    }).determinePreferredLanguage(function() {
      var avalaibleKeys, lang;
      lang = 'de';
      avalaibleKeys = ['de_DE', 'de-DE', 'de', 'en_US', 'en_UK', 'en-UK', 'en-US', 'en'];
      if (avalaibleKeys.indexOf(lang) === -1) {
        return 'de';
      } else {
        return lang;
      }
    }).fallbackLanguage('de').useCookieStorage().useSanitizeValueStrategy(null);
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').run(function($rootScope) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    return $urlRouterProvider.otherwise('/');
  });

}).call(this);



(function() {
  angular.module('oekoKostenrechner');

}).call(this);



(function() {
  angular.module('oekoKostenrechner').config(function($logProvider) {
    'ngInject';
    return $logProvider.debugEnabled(true);
  });

}).call(this);



angular.module('oekoKostenrechner')
  .directive("screenHeight", ["$window", function($window) {
    return function(scope, element, attrs) {
      var ev = "resize.screenHeight-" + _.uniqueId();
      var resize = function() {
        if (!isNaN(attrs.screenHeight)) {
        	element.css("min-height", Math.max(attrs.screenHeight,  $window.innerHeight) );
        } else {
          element.css("min-height", $window.innerHeight);
        }
      };
      
      resize();
      angular.element($window).bind(ev, resize);

      scope.$on('$destroy', function() {
        angular.element($window).unbind(ev);
      });
    };
  }
]);

var PricePredictionScenario;
(function (PricePredictionScenario) {
    PricePredictionScenario[PricePredictionScenario["Optimistic"] = 0] = "Optimistic";
    PricePredictionScenario[PricePredictionScenario["Neutral"] = 1] = "Neutral";
    PricePredictionScenario[PricePredictionScenario["Pessimistic"] = 2] = "Pessimistic";
})(PricePredictionScenario || (PricePredictionScenario = {}));
var InterpolationType;
(function (InterpolationType) {
    InterpolationType[InterpolationType["Min"] = 0] = "Min";
    InterpolationType[InterpolationType["Max"] = 1] = "Max";
})(InterpolationType || (InterpolationType = {}));
var HoldingPeriodCosts = /** @class */ (function () {
    function HoldingPeriodCosts(params) {
        this.params = params;
    }
    HoldingPeriodCosts.prototype.purchase = function (residualValueFactor) {
        if (residualValueFactor === void 0) { residualValueFactor = 1; }
        return this.params.listPrice
            .add(this.otherPurchaseCosts)
            .sub(this.fundings)
            .sub(this.params.residualValue.multiply(residualValueFactor));
    };
    Object.defineProperty(HoldingPeriodCosts.prototype, "otherPurchaseCosts", {
        get: function () {
            return this.params.transferAndAdmissionFee.add(this.params.annualOther.total(this.params.holdingPeriod));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "fundings", {
        get: function () {
            return this.params.funding.add(this.params.annualFunding.total(this.params.holdingPeriod));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "chargingInfrastructure", {
        get: function () {
            return this.chargingInfrastructurePurchase.add(this.chargingInfrastructureMaintenance);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "chargingInfrastructurePurchase", {
        get: function () {
            if (!this.params.needsChargingInfrastructure) {
                return this.params.createMoney();
            }
            return this.inflate(this.params.chargingStationPurchasePrice, this.params.purchaseYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "chargingInfrastructureMaintenance", {
        get: function () {
            if (!this.params.needsChargingInfrastructure) {
                return this.params.createMoney();
            }
            return this.params.chargingStationMaintenance.totalInflated(this.params.holdingPeriod, this.params.inflation, this.params.dataYear, this.params.purchaseYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "fixed", {
        get: function () {
            return this.insurance.add(this.vehicleTaxes);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "insurance", {
        get: function () {
            return this.params.insurance.totalInflated(this.params.holdingPeriod, this.params.inflation, this.params.dataYear, this.params.purchaseYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "vehicleTaxes", {
        get: function () {
            var taxPeriod = this.params.holdingPeriod;
            if (this.params.driveType === DriveType.Electric && this.params.purchaseYear < 2031) {
                taxPeriod = Years.createFromInterval(Math.max(this.params.purchaseYear, 2036), Math.max(this.params.purchaseYear + this.params.holdingPeriod.yearCount, 2036));
            }
            return this.params.vehicleTax.total(taxPeriod);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "energy", {
        get: function () {
            var accumulatedPrice = this.params.createMoney();
            for (var _i = 0, _a = this.holdingPeriodYears; _i < _a.length; _i++) {
                var year = _a[_i];
                var price = void 0;
                if (this.params.driveType === DriveType.Electric) {
                    price = this.energyPriceElectric(year);
                }
                else {
                    price = this.energyPricePetrol(year);
                }
                accumulatedPrice = accumulatedPrice.add(price);
            }
            return accumulatedPrice
                .multiply(this.realUsageConsumption)
                .multiply(this.params.mileage.annualMileage / 100);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "realUsageConsumption", {
        get: function () {
            var realConsumption = new EnergyConsumption(this.params.realEnergyFactor);
            return realConsumption.laboratoryToUsageSpecific(this.params.energyConsumption, this.params.roadUsageDistribution, this.params.roadTypeConsumption);
        },
        enumerable: false,
        configurable: true
    });
    HoldingPeriodCosts.prototype.energyPriceElectric = function (year) {
        return this.energyPriceElectricPrivate(year).multiply(1 - this.params.publicCharging)
            .add(this.energyPriceElectricPublic(year).multiply(this.params.publicCharging));
    };
    HoldingPeriodCosts.prototype.energyPriceElectricPrivate = function (year) {
        return this.energyPricePredicted(year).price;
    };
    HoldingPeriodCosts.prototype.energyPriceElectricPublic = function (year) {
        return this.inflatePrice(this.params.energyPricePublicCharging, year).price;
    };
    HoldingPeriodCosts.prototype.energyPricePetrol = function (year) {
        return this.energyPricePredicted(year).price;
    };
    HoldingPeriodCosts.prototype.energyPricePredicted = function (year) {
        var factor = 1;
        var energyPrice = this.params.energyPrice;
        for (var factorYear = energyPrice.priceYear + 1; factorYear <= year; factorYear++) {
            factor *= this.params.energyPricePredictionFactor(factorYear, this.params.driveType);
        }
        var predictedPrice = energyPrice.price
            .sub(this.emissionPrice(energyPrice.priceYear, false))
            .multiply(factor);
        var inflated = this.params.inflation.inflate(predictedPrice, Years.createFromInterval(energyPrice.priceYear, year));
        return new Price(inflated.add(this.emissionPrice(year, true)), year);
    };
    HoldingPeriodCosts.prototype.emissionPrice = function (year, withOverwrite) {
        return this.params.taxRate.toGross(this.params.co2TaxPrice(year, this.params.driveType, withOverwrite)
            .multiply(this.params.co2TaxEmissionFactor(this.params.driveType))
            .multiply(this.params.co2TaxHeatingValue(this.params.driveType))
            .divide(Math.pow(10, 6)));
    };
    Object.defineProperty(HoldingPeriodCosts.prototype, "tires", {
        get: function () {
            var replaceYear = this.params.purchaseYear + (this.params.holdingPeriod.yearCount - 1) / 2;
            var tirePrice = this.inflate(this.params.tirePrice, replaceYear);
            var totalMileage = this.params.mileage.totalMileage(this.params.holdingPeriod).kilometers;
            if (this.params.tireMileage === null || this.params.tireMileage.kilometers <= 0) {
                return this.params.createMoney();
            }
            var tireUsageFactor = totalMileage / this.params.tireMileage.kilometers;
            return tirePrice.multiply(tireUsageFactor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "maintenancePerYear", {
        get: function () {
            if (this.params.maintenanceCostsTotal !== null) {
                return this.params.maintenanceCostsTotal;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "maintenance", {
        get: function () {
            if (this.maintenancePerYear !== null) {
                return this.accumulateInflated(this.maintenancePerYear);
            }
            return this.accumulateInflated(this.params.repairCosts()
                .add(this.params.inspectionCosts()));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "lubricantsAndResources", {
        get: function () {
            if (this.params.operatingCosts !== null) {
                return this.params.operatingCosts.total(this.params.holdingPeriod);
            }
            return this.lubricants.add(this.adBlue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "lubricants", {
        get: function () {
            return this.accumulateInflated(this.params.lubricants);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "holdingPeriodYears", {
        get: function () {
            return this.params.holdingPeriod.years(this.params.purchaseYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "adBlue", {
        get: function () {
            return this.accumulateInflated(this.params.adBlue);
        },
        enumerable: false,
        configurable: true
    });
    HoldingPeriodCosts.prototype.accumulateInflated = function (money) {
        var total = this.params.createMoney();
        for (var _i = 0, _a = this.holdingPeriodYears; _i < _a.length; _i++) {
            var year = _a[_i];
            total = total.add(this.inflate(money.money, year));
        }
        return total;
    };
    Object.defineProperty(HoldingPeriodCosts.prototype, "repairAndMaintenance", {
        get: function () {
            return this.tires
                .add(this.maintenance)
                .add(this.lubricantsAndResources);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "total", {
        get: function () {
            return this.purchase()
                .add(this.chargingInfrastructure)
                .add(this.fixed)
                .add(this.energy)
                .add(this.repairAndMaintenance);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "totalPro", {
        get: function () {
            return this.purchase(0.9)
                .add(this.chargingInfrastructure)
                .add(this.fixed)
                .add(this.energy.multiply(1.1))
                .add(this.repairAndMaintenance);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HoldingPeriodCosts.prototype, "totalContra", {
        get: function () {
            return this.purchase(1.1)
                .add(this.chargingInfrastructure)
                .add(this.fixed)
                .add(this.energy.multiply(0.9))
                .add(this.repairAndMaintenance);
        },
        enumerable: false,
        configurable: true
    });
    HoldingPeriodCosts.prototype.inflate = function (money, targetYear) {
        return this.params.inflation.inflate(money, this.inflationPeriod(targetYear));
    };
    HoldingPeriodCosts.prototype.inflatePrice = function (price, targetYear) {
        return new Price(this.params.inflation.inflate(price.price, Years.createFromInterval(price.priceYear, targetYear)), targetYear);
    };
    HoldingPeriodCosts.prototype.inflationPeriod = function (targetYear) {
        return new Years(targetYear - this.params.dataYear);
    };
    return HoldingPeriodCosts;
}());
var EnergyConsumption = /** @class */ (function () {
    function EnergyConsumption(realConsumptionFactor) {
        this.realConsumptionFactor = realConsumptionFactor;
    }
    EnergyConsumption.prototype.laboratoryToReal = function (labConsumption) {
        return this.realConsumptionFactor * labConsumption;
    };
    EnergyConsumption.prototype.genericToUsageSpecific = function (consumption, usage, roadFactor) {
        var factor = usage.urban * roadFactor.urban + usage.rural * roadFactor.rural + usage.motorway * roadFactor.motorway;
        return consumption * factor;
    };
    EnergyConsumption.prototype.laboratoryToUsageSpecific = function (labConsumption, usage, roadFactor) {
        var real = this.laboratoryToReal(labConsumption);
        return this.genericToUsageSpecific(real, usage, roadFactor);
    };
    return EnergyConsumption;
}());
var UserParameters = /** @class */ (function () {
    function UserParameters(inputs, lockedInputs, vehicleService) {
        this.vehicle = null;
        this.mileageOverwrite = null;
        this.holdingPeriodOverwrite = null;
        this.purchaseYearOverwrite = null;
        this.co2TaxPriceStatic = null;
        this.inputs = inputs;
        this.lockedInputs = lockedInputs;
        this.vehicleService = vehicleService;
    }
    Object.defineProperty(UserParameters.prototype, "holdingPeriod", {
        get: function () {
            if (this.holdingPeriodOverwrite !== null) {
                return this.holdingPeriodOverwrite;
            }
            if (this.inputs.holding_time !== undefined) {
                return new Years(this.inputs.holding_time);
            }
            return new Years(6);
        },
        set: function (period) {
            this.holdingPeriodOverwrite = period;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "mileage", {
        get: function () {
            if (this.mileageOverwrite !== null) {
                return this.mileageOverwrite;
            }
            return new AnnualMileage(this.inputs.mileage, MileageUnit.Kilometer);
        },
        set: function (mileage) {
            this.mileageOverwrite = mileage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "listPrice", {
        get: function () {
            if (this.lockedInputs.acquisition_price && this.inputs.acquisition_price !== undefined) {
                return Euro.create(this.inputs.acquisition_price);
            }
            return this.vehicleData.listPrice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "residualValue", {
        get: function () {
            if (this.lockedInputs.residual_value_fixed && this.inputs.residual_value_fixed !== undefined) {
                return Euro.create(this.inputs.residual_value_fixed);
            }
            if (this.vehicleData.residualValue !== null) {
                return this.vehicleData.residualValue;
            }
            return this.calcResidualValue(this.listPrice);
        },
        enumerable: false,
        configurable: true
    });
    UserParameters.prototype.calcResidualValue = function (listPrice) {
        return listPrice.multiply(this.residualValueFactor.factor);
    };
    Object.defineProperty(UserParameters.prototype, "funding", {
        get: function () {
            if (this.lockedInputs.praemie && this.inputs.praemie !== undefined) {
                return Euro.create(this.inputs.praemie);
            }
            return new Euro(0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "annualOther", {
        get: function () {
            if (this.lockedInputs.fixed_costs_other && this.inputs.fixed_costs_other !== undefined) {
                return new MoneyPerYear(Euro.create(this.inputs.fixed_costs_other));
            }
            return new MoneyPerYear(Euro.create(0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "annualFunding", {
        get: function () {
            if (this.lockedInputs.fixed_funding && this.inputs.fixed_funding !== undefined) {
                return new MoneyPerYear(Euro.create(this.inputs.fixed_funding));
            }
            return new MoneyPerYear(Euro.create(0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "purchaseYear", {
        get: function () {
            if (this.purchaseYearOverwrite !== null) {
                return this.purchaseYearOverwrite;
            }
            return this.inputs.acquisition_year;
        },
        set: function (purchaseYear) {
            this.purchaseYearOverwrite = purchaseYear;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "energyConsumption", {
        get: function () {
            if (this.driveType === DriveType.Electric
                && this.lockedInputs.electricity_consumption
                && this.inputs.electricity_consumption !== undefined) {
                return this.inputs.electricity_consumption;
            }
            if (this.driveType !== DriveType.Electric
                && this.lockedInputs.fuel_consumption
                && this.inputs.fuel_consumption !== undefined) {
                return this.inputs.fuel_consumption;
            }
            return this.vehicleData.energyConsumption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "vehicleData", {
        get: function () {
            if (this.vehicle === null) {
                throw new Error("Vehicle data not yet loaded");
            }
            var needsInterpolation = false;
            if (this.vehicle.holdingPeriod.yearCount !== this.holdingPeriod.yearCount) {
                // console.warn("Vehicle data not updated, holding period (is|should): " + this.vehicle.holdingPeriod.yearCount + '|' + this.holdingPeriod.yearCount, this);
                // throw new Error("Vehicle data not updated, holding period (is|should): " + this.vehicle.holdingPeriod.yearCount + '|' + this.holdingPeriod.yearCount);
                needsInterpolation = true;
            }
            if (this.vehicle.mileage.kilometers !== this.mileage.kilometers) {
                // console.warn("Vehicle data not updated, mileage (is|should): " + this.vehicle.mileage.kilometers + '|' + this.mileage.kilometers, this);
                // throw new Error("Vehicle data not updated, mileage (is|should): " + this.vehicle.mileage.kilometers + '|' + this.mileage.kilometers);
                needsInterpolation = true;
            }
            if (needsInterpolation) {
                this.vehicle = this.vehicleService.updateInterpolated(this.vehicle, this.holdingPeriod, this.mileage);
            }
            if (this.vehicle.holdingPeriod.yearCount !== this.holdingPeriod.yearCount) {
                console.warn("Vehicle data not updated, holding period (is|should): " + this.vehicle.holdingPeriod.yearCount + '|' + this.holdingPeriod.yearCount, this);
                // throw new Error("Vehicle data not updated, holding period (is|should): " + this.vehicle.holdingPeriod.yearCount + '|' + this.holdingPeriod.yearCount);
            }
            if (this.vehicle.mileage.kilometers !== this.mileage.kilometers) {
                console.warn("Vehicle data not updated, mileage (is|should): " + this.vehicle.mileage.kilometers + '|' + this.mileage.kilometers, this);
                // throw new Error("Vehicle data not updated, mileage (is|should): " + this.vehicle.mileage.kilometers + '|' + this.mileage.kilometers);
            }
            return this.vehicle;
        },
        enumerable: false,
        configurable: true
    });
    UserParameters.prototype.updateVehicleData = function () {
        var _this = this;
        var result = null;
        if (this.inputs.vehicle !== undefined) {
            result = this.vehicleService.getSpecific(this.inputs.vehicle, this.toVehicleClass(this.inputs.car_type), this.toDriveType(this.inputs.energy_type), this.holdingPeriod, this.mileage);
        }
        if (result === null) {
            result = this.vehicleService.getGeneric(this.toVehicleClass(this.inputs.car_type), this.toDriveType(this.inputs.energy_type), this.holdingPeriod, this.mileage);
        }
        if (result === null) {
            result = this.vehicleService.getGeneric(this.toVehicleClass(this.inputs.car_type), DriveType.Petrol, this.holdingPeriod, this.mileage);
        }
        return result.then(function (vehicleData) {
            _this.vehicle = vehicleData;
            return true;
        });
    };
    UserParameters.prototype.toVehicleClass = function (car_type) {
        switch (car_type) {
            case 'kleinst':
                return VehicleClass.Tiny;
            case 'klein':
                return VehicleClass.Small;
            case 'kompakt':
                return VehicleClass.Compact;
            case 'mittel':
                return VehicleClass.Middle;
            case 'ober':
                return VehicleClass.Upper;
            case 'suv':
                return VehicleClass.SUV;
        }
    };
    UserParameters.prototype.toDriveType = function (energy_type) {
        switch (energy_type) {
            case 'diesel':
                return DriveType.Diesel;
            case 'bev':
                return DriveType.Electric;
            default:
                return DriveType.Petrol;
        }
    };
    Object.defineProperty(UserParameters.prototype, "publicCharging", {
        get: function () {
            if (this.lockedInputs.public_charging_proportion && this.inputs.public_charging_proportion !== undefined) {
                return this.inputs.public_charging_proportion / 100;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "photovoltaik", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "roadUsageDistribution", {
        get: function () {
            var distribution = {
                motorway: 0.4,
                rural: 0.2,
                urban: 0.4
            };
            if (this.inputs.highway_use !== undefined) {
                distribution.motorway = this.inputs.highway_use / 100;
                distribution.motorway = Math.max(0, distribution.motorway);
                distribution.motorway = Math.min(distribution.motorway, 1);
            }
            if (this.inputs.urban_use !== undefined) {
                distribution.urban = this.inputs.urban_use / 100;
                distribution.urban = Math.max(0, distribution.urban);
                distribution.urban = Math.min(distribution.urban, 1 - distribution.motorway);
            }
            distribution.rural = 1 - (distribution.motorway + distribution.urban);
            return distribution;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "insurance", {
        get: function () {
            if (this.lockedInputs.fixed_costs_insurance && this.inputs.fixed_costs_insurance !== undefined) {
                return new MoneyPerYear(new Euro(this.inputs.fixed_costs_insurance));
            }
            return this.vehicleData.insurance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "needsChargingInfrastructure", {
        get: function () {
            if (this.lockedInputs.charging_option && this.inputs.charging_option !== undefined) {
                return this.inputs.charging_option && this.vehicleData.needsChargingInfrastructure;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "vehicleTax", {
        get: function () {
            if (this.lockedInputs.fixed_costs_car_tax && this.inputs.fixed_costs_car_tax !== undefined) {
                return new MoneyPerYear(Euro.create(this.inputs.fixed_costs_car_tax));
            }
            return this.vehicleData.vehicleTax;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "chargingStationPurchasePrice", {
        get: function () {
            if (this.lockedInputs.charging_option_cost && this.inputs.charging_option_cost !== undefined) {
                return Euro.create(this.inputs.charging_option_cost);
            }
            return Euro.create(2630.);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "chargingStationMaintenance", {
        get: function () {
            if (this.lockedInputs.maintenance_costs_charger && this.inputs.maintenance_costs_charger !== undefined) {
                return new MoneyPerYear(Euro.create(this.inputs.maintenance_costs_charger));
            }
            return new MoneyPerYear(Euro.create(75.));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "dataYear", {
        get: function () {
            return 2026;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "driveType", {
        get: function () {
            return this.vehicleData.driveType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "energyPrice", {
        get: function () {
            switch (this.driveType) {
                case DriveType.Electric:
                    if (this.lockedInputs.current_electricity_price && this.inputs.current_electricity_price !== undefined) {
                        return new Price(Euro.create(this.inputs.current_electricity_price), this.inputs.acquisition_year);
                    }
                    return new Price(Euro.create(0.37), 2026);
                case DriveType.Petrol:
                    if (this.lockedInputs.current_petrol_price && this.inputs.current_petrol_price !== undefined) {
                        return new Price(Euro.create(this.inputs.current_petrol_price), this.inputs.acquisition_year);
                    }
                    return new Price(Euro.create(1.9894), 2026);
                case DriveType.Diesel:
                    if (this.lockedInputs.current_petrol_price && this.inputs.current_petrol_price !== undefined) {
                        return new Price(Euro.create(this.inputs.current_petrol_price), this.inputs.acquisition_year);
                    }
                    return new Price(Euro.create(2.019), 2026);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "energyPricePublicCharging", {
        get: function () {
            if (this.lockedInputs.public_charging_price && this.inputs.public_charging_price !== undefined) {
                return new Price(Euro.create(this.inputs.public_charging_price), this.purchaseYear);
            }
            return new Price(Euro.create(0.59), this.dataYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "inflation", {
        get: function () {
            if (this.inputs.inflationsrate !== undefined) {
                return Inflation.createByPercent(this.inputs.inflationsrate);
            }
            return Inflation.createByPercent(2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "lubricants", {
        get: function () {
            return this.vehicleData.lubricants;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "adBlue", {
        get: function () {
            return this.vehicleData.adBlue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "operatingCosts", {
        get: function () {
            if (this.lockedInputs.operating_costs && this.inputs.operating_costs !== undefined) {
                return new MoneyPerYear(new Euro(this.inputs.operating_costs));
            }
            return this.vehicleData.operatingFluid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "realEnergyFactor", {
        get: function () {
            if (this.lockedInputs.consumption_real_surcharge && this.inputs.consumption_real_surcharge !== undefined) {
                return 1 + this.inputs.consumption_real_surcharge / 100;
            }
            switch (this.driveType) {
                case DriveType.Electric:
                    return 1.18;
                case DriveType.Petrol:
                case DriveType.Diesel:
                    return 1.165;
            }
            this.throwDriveTypeError();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "residualValueFactor", {
        get: function () {
            return new ResidualValueFactor(this.holdingPeriod, this.mileage, this.vehicleData.residualValueParameters);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "residualValueParametersCombustion", {
        get: function () {
            return {
                get a() {
                    return 0.92041285;
                }, get b() {
                    return -0.175675;
                }, get c() {
                    return -0.000008;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "maintenanceCostsTotal", {
        get: function () {
            if (this.lockedInputs.maintenance_costs_total && this.inputs.maintenance_costs_total !== undefined) {
                return new MoneyPerYear(Euro.create(this.inputs.maintenance_costs_total));
            }
            return this.vehicle.maintenance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "residualValueParametersElectric", {
        get: function () {
            return {
                get a() {
                    return 1.06835683;
                }, get b() {
                    return -0.245266;
                }, get c() {
                    return -0.000011;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "roadTypeConsumption", {
        get: function () {
            switch (this.driveType) {
                case DriveType.Electric:
                    return {
                        motorway: 1.16237052053045,
                        rural: 0.892604813257665,
                        urban: 0.955194176871011
                    };
                case DriveType.Petrol:
                    return {
                        motorway: 1.06144351308346,
                        rural: 0.897715153742716,
                        urban: 1.04754557911106
                    };
                case DriveType.Diesel:
                    return {
                        motorway: 1.06091383565946,
                        rural: 0.924308466632711,
                        urban: 1.02336640940203
                    };
            }
            this.throwDriveTypeError();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "taxRate", {
        get: function () {
            return new TaxRate(1.19);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "tireMileage", {
        get: function () {
            return this.vehicleData.tireMileage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "tirePrice", {
        get: function () {
            var _a;
            if (this.lockedInputs.maintenance_costs_tires && this.inputs.maintenance_costs_tires !== undefined) {
                return Euro.create(this.inputs.maintenance_costs_tires);
            }
            return (_a = this.vehicleData.tirePrice) !== null && _a !== void 0 ? _a : this.createMoney();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "transferAndAdmissionFee", {
        get: function () {
            return Euro.create(500);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "vehicleClass", {
        get: function () {
            return this.vehicleData.vehicleClass;
        },
        enumerable: false,
        configurable: true
    });
    UserParameters.prototype.repairCosts = function () {
        if (this.lockedInputs.maintenance_costs_repairs && this.inputs.maintenance_costs_repairs !== undefined) {
            return new MoneyPerYear(Euro.create(this.inputs.maintenance_costs_repairs));
        }
        return this.vehicleData.repairWork.add(this.vehicleData.repairMaterial);
    };
    UserParameters.prototype.inspectionCosts = function () {
        if (this.lockedInputs.maintenance_costs_inspection && this.inputs.maintenance_costs_inspection !== undefined) {
            return new MoneyPerYear(Euro.create(this.inputs.maintenance_costs_inspection));
        }
        return this.vehicleData.inspectionWork.add(this.vehicleData.inspectionMaterial);
    };
    UserParameters.prototype.co2TaxEmissionFactor = function (driveType) {
        switch (driveType) {
            case DriveType.Electric:
                return 0;
            case DriveType.Petrol:
                return 72.9;
            case DriveType.Diesel:
                return 74;
        }
        this.throwDriveTypeError(driveType);
    };
    UserParameters.prototype.co2TaxHeatingValue = function (driveType) {
        switch (driveType) {
            case DriveType.Electric:
                return 0;
            case DriveType.Petrol:
                return 32.8425;
            case DriveType.Diesel:
                return 36.166;
        }
    };
    UserParameters.prototype.co2TaxPrice = function (year, driveType, withOverwrite) {
        if (driveType === DriveType.Electric) {
            return Euro.create(0);
        }
        if (withOverwrite && this.co2TaxPriceStatic !== null) {
            return this.co2TaxPriceStatic;
        }
        var start = 2021;
        var data = [
            25, 30, 30, 45, 55, 65, 80, 95, 110, 125, 140, 155, 170, 185, 200, 215, 230,
            245, 260, 275, 290, 305, 320, 335, 350, 365, 380, 395, 410, 425, 440
        ];
        var key = year - start;
        if (key < 0 || data.length === 0) {
            return Euro.create(0);
        }
        if (key in data) {
            return Euro.create(data[key]);
        }
        var last = data.pop();
        if (last !== undefined) {
            return Euro.create(last);
        }
        throw new Error('Last co2 price is undefined');
    };
    UserParameters.prototype.createMoney = function () {
        return Euro.create(0);
    };
    UserParameters.prototype.energyPricePredictionFactor = function (year, driveType) {
        return this.predictionScenarioFactor;
    };
    UserParameters.prototype.throwDriveTypeError = function (driveType) {
        if (typeof driveType === "undefined") {
            driveType = this.driveType;
        }
        throw Error("drive type ".concat(driveType, " not implemented"));
    };
    Object.defineProperty(UserParameters.prototype, "vehicleDescription", {
        get: function () {
            return this.vehicleData.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "vehicleModels", {
        get: function () {
            return this.vehicleService.getVehicleModels(this.vehicleClass, this.driveType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "predictionScenarioFactor", {
        get: function () {
            switch (this.predictionScenario) {
                case PricePredictionScenario.Optimistic:
                    return 0.99;
                case PricePredictionScenario.Neutral:
                    return 1;
                case PricePredictionScenario.Pessimistic:
                    return 1.01;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserParameters.prototype, "predictionScenario", {
        get: function () {
            if (this.inputs.price_scenario !== undefined) {
                switch (this.inputs.price_scenario) {
                    case 'optimistic':
                        return PricePredictionScenario.Optimistic;
                    case 'pessimistic':
                        return PricePredictionScenario.Pessimistic;
                }
            }
            return PricePredictionScenario.Neutral;
        },
        enumerable: false,
        configurable: true
    });
    return UserParameters;
}());
var VehicleDataService = /** @class */ (function () {
    function VehicleDataService(vehicleList, vehicleDataService) {
        this.vehicleList = vehicleList;
        this.dataService = vehicleDataService;
    }
    VehicleDataService.prototype.getSpecific = function (name, vehicleClass, driveType, holdingPeriod, mileage) {
        var _this = this;
        var vehicleData = this.getVehicleModel(vehicleClass, driveType, name);
        if (vehicleData === null) {
            return null;
        }
        return this.dataService.getVehicleDataByUuid(vehicleData.uuid)
            .then(function (response) {
            return _this.createVehicleData(response.data, vehicleClass, driveType, holdingPeriod, mileage);
        });
    };
    VehicleDataService.prototype.getGeneric = function (vehicleClass, driveType, holdingPeriod, mileage) {
        var _this = this;
        var vehicleData = this.getVehicleModel(vehicleClass, driveType, 'Beispiel');
        if (vehicleData === null) {
            return null;
        }
        return this.dataService.getVehicleDataByUuid(vehicleData.uuid)
            .then(function (response) {
            return _this.createVehicleData(response.data, vehicleClass, driveType, holdingPeriod, mileage);
        })
            .catch(function () { return null; });
    };
    VehicleDataService.prototype.getVehicleModel = function (vehicleClass, driveType, description) {
        for (var _i = 0, _a = this.vehicleList; _i < _a.length; _i++) {
            var model = _a[_i];
            if (model.description.indexOf(description) !== 0) {
                continue;
            }
            if (!this.compareDriveType(driveType, model.driveType)) {
                continue;
            }
            if (!this.compareVehicleClass(vehicleClass, model.vehicleClass)) {
                continue;
            }
            return model;
        }
        return null;
    };
    VehicleDataService.prototype.getVehicleModels = function (vehicleClass, driveType) {
        var names = [];
        for (var _i = 0, _a = this.vehicleList; _i < _a.length; _i++) {
            var model = _a[_i];
            if (!this.compareDriveType(driveType, model.driveType)) {
                continue;
            }
            if (!this.compareVehicleClass(vehicleClass, model.vehicleClass)) {
                continue;
            }
            names.push(model.description);
        }
        return names;
    };
    VehicleDataService.prototype.compareVehicleClass = function (vehicleClass, vehicleClassList) {
        if (vehicleClass === VehicleClass.Tiny) {
            return vehicleClassList.indexOf('Kleinstwagen') === 0;
        }
        if (vehicleClass === VehicleClass.Small) {
            return vehicleClassList.indexOf('Kleinwagen') === 0;
        }
        if (vehicleClass === VehicleClass.Compact) {
            return vehicleClassList.indexOf('Untere Mittelklasse') === 0;
        }
        if (vehicleClass === VehicleClass.Middle) {
            return vehicleClassList.indexOf('Mittelklasse') === 0;
        }
        if (vehicleClass === VehicleClass.Upper) {
            return vehicleClassList.indexOf('Obere Mittelklasse') === 0;
        }
        return false;
    };
    VehicleDataService.prototype.compareDriveType = function (driveType, driveTypeList) {
        if (driveType === DriveType.Electric) {
            return driveTypeList === 'Elektro';
        }
        if (driveType === DriveType.Petrol) {
            return driveTypeList === 'Otto';
        }
        if (driveType === DriveType.Diesel) {
            return driveTypeList === 'Diesel';
        }
        return false;
    };
    VehicleDataService.prototype.createVehicleData = function (vehicle, vehicleClass, driveType, holdingPeriod, mileage) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var interpolated = this.getInterpolated(vehicle.interpolation, holdingPeriod, mileage);
        if (interpolated === null) {
            throw new Error('Interpolation data is missing');
        }
        var vehicleData = {
            description: vehicle.description,
            mileage: mileage,
            holdingPeriod: holdingPeriod,
            driveType: driveType,
            vehicleClass: vehicleClass,
            residualValueParameters: this.getResidualValueParameters(driveType),
            listPrice: new Euro(vehicle.listPrice),
            vehicleTax: new MoneyPerYear(new Euro(vehicle.taxes)),
            insurance: new MoneyPerYear(new Euro(interpolated.insurance)),
            needsChargingInfrastructure: driveType === DriveType.Electric,
            energyConsumption: interpolated.consumption,
            tirePrice: new Euro((_a = vehicle.tires) !== null && _a !== void 0 ? _a : 0),
            tireMileage: null,
            lubricants: new MoneyPerYear(new Euro(((_b = interpolated.oil) !== null && _b !== void 0 ? _b : 0) * 12)),
            adBlue: new MoneyPerYear(new Euro(((_c = interpolated.adBlue) !== null && _c !== void 0 ? _c : 0) * 12)),
            inspectionMaterial: new MoneyPerYear(new Euro((_d = interpolated.inspectionMaterial) !== null && _d !== void 0 ? _d : 0)),
            inspectionWork: new MoneyPerYear(new Euro((_e = interpolated.inspectionWork) !== null && _e !== void 0 ? _e : 0)),
            repairMaterial: new MoneyPerYear(new Euro((_f = interpolated.repairMaterial) !== null && _f !== void 0 ? _f : 0)),
            repairWork: new MoneyPerYear(new Euro((_g = interpolated.repairWork) !== null && _g !== void 0 ? _g : 0)),
            maintenance: new MoneyPerYear(new Euro((_h = interpolated.maintenance) !== null && _h !== void 0 ? _h : 0)),
            operatingFluid: new MoneyPerYear(new Euro((_j = interpolated.operatingFluid) !== null && _j !== void 0 ? _j : 0)),
            residualValue: null,
            interpolation: vehicle.interpolation,
        };
        if (vehicle.tireMileage > 0) {
            vehicleData.tireMileage = new Mileage(vehicle.tireMileage, MileageUnit.Kilometer);
        }
        if (interpolated.residualValue !== null) {
            vehicleData.residualValue = new Euro(interpolated.residualValue);
        }
        return vehicleData;
    };
    VehicleDataService.prototype.updateInterpolated = function (vehicle, period, mileage) {
        var interpolated = this.getInterpolated(vehicle.interpolation, period, mileage);
        if (interpolated === null) {
            throw new Error('Interpolation data is missing');
        }
        vehicle.mileage = mileage;
        vehicle.holdingPeriod = period;
        vehicle.insurance = new MoneyPerYear(new Euro(interpolated.insurance));
        vehicle.energyConsumption = interpolated.consumption;
        vehicle.lubricants = new MoneyPerYear(new Euro(interpolated.oil * 12));
        vehicle.adBlue = new MoneyPerYear(new Euro(interpolated.adBlue * 12));
        vehicle.inspectionMaterial = new MoneyPerYear(new Euro(interpolated.inspectionMaterial));
        vehicle.inspectionWork = new MoneyPerYear(new Euro(interpolated.inspectionWork));
        vehicle.repairMaterial = new MoneyPerYear(new Euro(interpolated.repairMaterial));
        vehicle.repairWork = new MoneyPerYear(new Euro(interpolated.repairWork));
        vehicle.maintenance = new MoneyPerYear(new Euro(interpolated.maintenance));
        vehicle.operatingFluid = new MoneyPerYear(new Euro(interpolated.operatingFluid));
        return vehicle;
    };
    VehicleDataService.prototype.getInterpolated = function (dataPoints, period, mileage) {
        var patients = {
            mminHmin: null, mminHmax: null, mmaxHmin: null, mmaxHmax: null,
        };
        for (var _i = 0, dataPoints_1 = dataPoints; _i < dataPoints_1.length; _i++) {
            var point = dataPoints_1[_i];
            if (this.testPoint(point, mileage, InterpolationType.Min, period, InterpolationType.Min, patients.mminHmin)) {
                patients.mminHmin = point;
            }
            if (this.testPoint(point, mileage, InterpolationType.Min, period, InterpolationType.Max, patients.mminHmax)) {
                patients.mminHmax = point;
            }
            if (this.testPoint(point, mileage, InterpolationType.Max, period, InterpolationType.Min, patients.mmaxHmin)) {
                patients.mmaxHmin = point;
            }
            if (this.testPoint(point, mileage, InterpolationType.Max, period, InterpolationType.Max, patients.mmaxHmax)) {
                patients.mmaxHmax = point;
            }
        }
        var mmin = this.interpolatePatients('holdingPeriod', period.yearCount, patients.mminHmin, patients.mminHmax);
        var mmax = this.interpolatePatients('holdingPeriod', period.yearCount, patients.mmaxHmin, patients.mmaxHmax);
        return this.interpolatePatients('mileage', mileage.kilometers, mmin, mmax);
    };
    VehicleDataService.prototype.testPoint = function (point, mileage, mileageType, holdingPeriod, periodType, patient) {
        if (mileageType === InterpolationType.Min && point.mileage > mileage.kilometers) {
            return false;
        }
        if (mileageType === InterpolationType.Max && point.mileage < mileage.kilometers) {
            return false;
        }
        if (periodType === InterpolationType.Min && point.holdingPeriod > holdingPeriod.yearCount) {
            return false;
        }
        if (periodType === InterpolationType.Max && point.holdingPeriod < holdingPeriod.yearCount) {
            return false;
        }
        if (patient === null) {
            return true;
        }
        if (mileageType === InterpolationType.Min && patient.mileage > point.mileage) {
            return false;
        }
        if (mileageType === InterpolationType.Max && patient.mileage < point.mileage) {
            return false;
        }
        if (periodType === InterpolationType.Min && patient.holdingPeriod > point.holdingPeriod) {
            return false;
        }
        return !(periodType === InterpolationType.Max && patient.holdingPeriod < point.holdingPeriod);
    };
    VehicleDataService.prototype.interpolatePatients = function (interpolateBy, interpolateTarget, a, b) {
        if (a === null && b === null) {
            return null;
        }
        if (a === null) {
            return b;
        }
        if (b === null || a[interpolateBy] === b[interpolateBy]) {
            return a;
        }
        var result = {
            adBlue: 0,
            consumption: 0,
            holdingPeriod: 0,
            inspectionMaterial: 0,
            inspectionWork: 0,
            insurance: 0,
            mileage: 0,
            oil: 0,
            repairMaterial: 0,
            repairWork: 0,
            maintenance: 0,
            operatingFluid: 0,
            residualValue: 0,
        };
        result[interpolateBy] = interpolateTarget;
        var key;
        for (key in result) {
            if (key === interpolateBy) {
                continue;
            }
            var params = {
                x1: a[interpolateBy],
                x2: b[interpolateBy],
                y1: a[key],
                y2: b[key],
            };
            result[key] = this.interpolate(params, interpolateTarget);
        }
        return result;
    };
    VehicleDataService.prototype.interpolate = function (params, x) {
        return (params.y2 - params.y1) * (x - params.x1) / (params.x2 - params.x1) + (params.y1);
    };
    VehicleDataService.prototype.getResidualValueParameters = function (driveType) {
        if (driveType === DriveType.Electric) {
            return { a: 1.06835683, b: -0.245266, c: -0.000011 };
        }
        return { a: 0.92041285, b: -0.175675, c: -0.000008 };
    };
    return VehicleDataService;
}());
var DriveType;
(function (DriveType) {
    DriveType[DriveType["Electric"] = 0] = "Electric";
    DriveType[DriveType["Petrol"] = 1] = "Petrol";
    DriveType[DriveType["Diesel"] = 2] = "Diesel";
})(DriveType || (DriveType = {}));
var ResidualValueFactor = /** @class */ (function () {
    function ResidualValueFactor(holdingPeriod, mileage, modelParameters) {
        this.holdingPeriod = holdingPeriod;
        this.mileage = mileage;
        this.a = modelParameters.a;
        this.b = modelParameters.b;
        this.c = modelParameters.c;
    }
    Object.defineProperty(ResidualValueFactor.prototype, "factor", {
        get: function () {
            return this.a * this.ageFactor * this.mileageFactor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResidualValueFactor.prototype, "ageFactor", {
        get: function () {
            return Math.exp(this.b * this.holdingPeriod.yearCount);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResidualValueFactor.prototype, "mileageFactor", {
        get: function () {
            return Math.exp(this.c * this.mileage.totalMileage(new Years(1)).kilometers);
        },
        enumerable: false,
        configurable: true
    });
    return ResidualValueFactor;
}());
var TaxRate = /** @class */ (function () {
    function TaxRate(value) {
        this.value = value;
    }
    TaxRate.prototype.toGross = function (net) {
        return net.multiply(this.asDecimal);
    };
    TaxRate.prototype.toNet = function (gross) {
        return gross.divide(this.asDecimal);
    };
    Object.defineProperty(TaxRate.prototype, "asPercent", {
        get: function () {
            return this.value * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TaxRate.prototype, "asDecimal", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    return TaxRate;
}());
var VehicleClass;
(function (VehicleClass) {
    VehicleClass[VehicleClass["Tiny"] = 0] = "Tiny";
    VehicleClass[VehicleClass["Small"] = 1] = "Small";
    VehicleClass[VehicleClass["Compact"] = 2] = "Compact";
    VehicleClass[VehicleClass["Middle"] = 3] = "Middle";
    VehicleClass[VehicleClass["Upper"] = 4] = "Upper";
    VehicleClass[VehicleClass["SUV"] = 5] = "SUV";
})(VehicleClass || (VehicleClass = {}));
var PeriodType;
(function (PeriodType) {
    PeriodType[PeriodType["Year"] = 0] = "Year";
    PeriodType[PeriodType["Month"] = 1] = "Month";
    PeriodType[PeriodType["Week"] = 2] = "Week";
    PeriodType[PeriodType["Day"] = 3] = "Day";
    PeriodType[PeriodType["Hour"] = 4] = "Hour";
    PeriodType[PeriodType["Minute"] = 5] = "Minute";
    PeriodType[PeriodType["Second"] = 6] = "Second";
})(PeriodType || (PeriodType = {}));
var Years = /** @class */ (function () {
    function Years(years) {
        this.value = years;
        this.type = PeriodType.Year;
    }
    Years.createFromInterval = function (start, end) {
        return new Years(Math.abs(end - start));
    };
    Object.defineProperty(Years.prototype, "dayCount", {
        get: function () {
            return this.value * 365;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Years.prototype, "yearCount", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Years.prototype.years = function (start) {
        var years = [];
        for (var year = start; year < start + this.yearCount; year++) {
            years.push(year);
        }
        return years;
    };
    return Years;
}());
var AnnualMileage = /** @class */ (function () {
    function AnnualMileage(annualMileage, unit) {
        this.annualMileage = annualMileage;
        this.unit = unit;
    }
    Object.defineProperty(AnnualMileage.prototype, "kilometers", {
        get: function () {
            if (this.unit === MileageUnit.Kilometer) {
                return this.annualMileage;
            }
            throw Error("unit ".concat(this.unit, " not implemented in AnnualMileage.kilometers()"));
        },
        enumerable: false,
        configurable: true
    });
    AnnualMileage.prototype.totalMileage = function (period) {
        return new Mileage(this.annualMileage * period.yearCount, this.unit);
    };
    return AnnualMileage;
}());
var Mileage = /** @class */ (function () {
    function Mileage(value, valueUnit) {
        this.value = value;
        this.valueUnit = valueUnit;
    }
    Mileage.createKilometer = function (value) {
        return new Mileage(value, MileageUnit.Kilometer);
    };
    Object.defineProperty(Mileage.prototype, "kilometers", {
        get: function () {
            if (this.valueUnit === MileageUnit.Kilometer) {
                return this.value;
            }
            throw Error("unit ".concat(this.valueUnit, " not implemented in Mileage.kilometers()"));
        },
        enumerable: false,
        configurable: true
    });
    return Mileage;
}());
var MileageUnit;
(function (MileageUnit) {
    MileageUnit[MileageUnit["Kilometer"] = 0] = "Kilometer";
})(MileageUnit || (MileageUnit = {}));
var Currency;
(function (Currency) {
    Currency[Currency["Euro"] = 0] = "Euro";
})(Currency || (Currency = {}));
var Euro = /** @class */ (function () {
    function Euro(value) {
        if (isNaN(value)) {
            value = 0;
        }
        this.value = value;
        this.currency = Currency.Euro;
    }
    Euro.create = function (euro) {
        return new Euro(euro);
    };
    Euro.prototype.divide = function (divisor) {
        return Euro.create(this.value / divisor);
    };
    Euro.prototype.multiply = function (multiplier) {
        return Euro.create(this.value * multiplier);
    };
    Euro.prototype.add = function (money) {
        return Euro.create(this.value + money.value);
    };
    Euro.prototype.sub = function (money) {
        return Euro.create(this.value - money.value);
    };
    Euro.prototype.equal = function (money) {
        return this.value === money.value;
    };
    Euro.prototype.fewerThan = function (money) {
        return this.value < money.value;
    };
    Euro.prototype.fewerEqualThan = function (money) {
        return this.value <= money.value;
    };
    Euro.prototype.render = function (precision) {
        if (precision === undefined) {
            precision = 0;
        }
        var roundingFactor = Math.pow(10, precision);
        return Math.round(this.value * roundingFactor) / roundingFactor;
    };
    return Euro;
}());
var Inflation = /** @class */ (function () {
    function Inflation(inflationRate) {
        this.inflationRate = inflationRate;
    }
    Inflation.createByPercent = function (rateInPercent) {
        return new Inflation(rateInPercent / 100 + 1);
    };
    Object.defineProperty(Inflation.prototype, "asPercent", {
        get: function () {
            return (this.inflationRate - 1) * 100;
        },
        enumerable: false,
        configurable: true
    });
    Inflation.prototype.inflate = function (money, period) {
        return money.multiply(this.factor(period));
    };
    Inflation.prototype.factor = function (period) {
        return Math.pow(this.inflationRate, period.yearCount);
    };
    return Inflation;
}());
var MoneyPerYear = /** @class */ (function () {
    function MoneyPerYear(money) {
        this.money = money;
    }
    MoneyPerYear.prototype.total = function (timeSpan) {
        return this.money.multiply(timeSpan.yearCount);
    };
    MoneyPerYear.prototype.totalInflated = function (period, inflation, moneyYear, periodYear) {
        var total = this.money.multiply(0);
        for (var _i = 0, _a = period.years(periodYear); _i < _a.length; _i++) {
            var year = _a[_i];
            total = total.add(inflation.inflate(this.money, new Years(year - moneyYear)));
        }
        return total;
    };
    MoneyPerYear.prototype.inflate = function (inflation, period) {
        return new MoneyPerYear(inflation.inflate(this.money, period));
    };
    MoneyPerYear.prototype.add = function (money) {
        return new MoneyPerYear(this.money.add(money.money));
    };
    return MoneyPerYear;
}());
var Price = /** @class */ (function () {
    function Price(price, priceYear) {
        this.price = price;
        this.priceYear = priceYear;
    }
    return Price;
}());
var Facade = /** @class */ (function () {
    function Facade(vehicleData, vehicleDetails) {
        this.vehicleData = vehicleData;
        this.vehicleDetails = vehicleDetails;
    }
    Facade.prototype.createParameters = function (input, lockedInputs) {
        var params = new UserParameters(input, lockedInputs, this.vehicleService());
        return params.updateVehicleData()
            .then(function () { return params; });
    };
    Facade.prototype.createCalculator = function (parameters) {
        return new HoldingPeriodCosts(parameters);
    };
    Facade.prototype.toCarType = function (vehicleClass) {
        switch (vehicleClass) {
            case VehicleClass.Tiny:
                return 'kleinst';
            case VehicleClass.Small:
                return 'klein';
            case VehicleClass.Compact:
                return 'kompakt';
            case VehicleClass.Middle:
                return 'mittel';
            case VehicleClass.Upper:
                return 'ober';
            case VehicleClass.SUV:
                return 'suv';
        }
    };
    Facade.prototype.toEnergyType = function (driveType) {
        switch (driveType) {
            case DriveType.Electric:
                return 'bev';
            case DriveType.Petrol:
                return 'petrol';
            case DriveType.Diesel:
                return 'diesel';
        }
    };
    Facade.prototype.toPriceScenario = function (scenario) {
        switch (scenario) {
            case PricePredictionScenario.Optimistic:
                return 'optimistic';
            case PricePredictionScenario.Pessimistic:
                return 'pessimistic';
        }
        return 'neutral';
    };
    Facade.prototype.updateVehicleInput = function (vehicleInput, calculator) {
        var parameters = calculator.params;
        vehicleInput.mileage = parameters.mileage.annualMileage;
        vehicleInput.car_type = this.toCarType(parameters.vehicleClass);
        vehicleInput.energy_type = this.toEnergyType(parameters.driveType);
        vehicleInput.acquisition_year = parameters.purchaseYear;
        vehicleInput.acquisition_price = calculator.params.listPrice.render();
        vehicleInput.charging_option = parameters.needsChargingInfrastructure;
        vehicleInput.charging_option_cost = parameters.chargingStationPurchasePrice.render();
        if (calculator.params.driveType === DriveType.Electric) {
            vehicleInput.electricity_consumption = this.round(calculator.params.energyConsumption);
            vehicleInput.fuel_consumption = 0;
            vehicleInput.current_electricity_price = calculator.energyPriceElectricPrivate(parameters.purchaseYear).render(3);
            vehicleInput.current_petrol_price = 0;
            vehicleInput.fuel_consumption_real = 0;
            vehicleInput.electricity_consumption_real = this.round(calculator.realUsageConsumption);
        }
        else {
            vehicleInput.electricity_consumption = 0;
            vehicleInput.fuel_consumption = this.round(parameters.energyConsumption);
            vehicleInput.current_electricity_price = 0;
            vehicleInput.current_petrol_price = calculator.energyPricePetrol(parameters.purchaseYear).render(3);
            vehicleInput.fuel_consumption_real = this.round(calculator.realUsageConsumption);
            vehicleInput.electricity_consumption_real = 0;
        }
        vehicleInput.fixed_costs_car_tax = parameters.vehicleTax.money.render();
        vehicleInput.fixed_costs_insurance = parameters.insurance.money.render();
        vehicleInput.fixed_costs_total = parameters.insurance.add(parameters.vehicleTax).money.render();
        vehicleInput.holding_time = parameters.holdingPeriod.yearCount;
        vehicleInput.inflationsrate = this.round(parameters.inflation.asPercent);
        vehicleInput.maintenance_costs_charger = parameters.chargingStationMaintenance.money.render();
        vehicleInput.maintenance_costs_inspection = parameters.inspectionCosts().money.render();
        vehicleInput.maintenance_costs_repairs = parameters.repairCosts().money.render();
        vehicleInput.maintenance_costs_tires = parameters.tirePrice.render();
        vehicleInput.praemie = parameters.funding.render();
        vehicleInput.residual_value_fixed = parameters.residualValue.render();
        vehicleInput.highway_use = this.round(parameters.roadUsageDistribution.motorway * 100);
        vehicleInput.rural_use = this.round(parameters.roadUsageDistribution.rural * 100);
        vehicleInput.urban_use = this.round(parameters.roadUsageDistribution.urban * 100);
        vehicleInput.consumption_real_surcharge = this.round((parameters.realEnergyFactor - 1) * 100);
        vehicleInput.vehicle = parameters.vehicleDescription;
        vehicleInput.models = parameters.vehicleModels;
        vehicleInput.public_charging_price = calculator.energyPriceElectricPublic(parameters.purchaseYear).render(3);
        vehicleInput.public_charging_proportion = Math.round(parameters.publicCharging * 100);
        vehicleInput.fixed_costs_other = parameters.annualOther.money.render();
        vehicleInput.fixed_funding = parameters.annualFunding.money.render();
        vehicleInput.operating_costs = calculator.lubricantsAndResources.divide(parameters.holdingPeriod.yearCount).render();
        vehicleInput.price_scenario = this.toPriceScenario(parameters.predictionScenario);
        vehicleInput.maintenance_costs_total = calculator.maintenancePerYear.money.render();
    };
    Facade.prototype.round = function (value) {
        return Math.round(value * 100) / 100;
    };
    Facade.prototype.exportVehicle = function (vehicle, lockedInputs) {
        var exported = {};
        exported.mileage = vehicle.mileage;
        exported.acquisition_year = vehicle.acquisition_year;
        exported.holding_time = vehicle.holding_time;
        exported.vehicle = vehicle.vehicle;
        exported.highway_use = vehicle.highway_use;
        exported.urban_use = vehicle.urban_use;
        exported.inflationsrate = vehicle.inflationsrate;
        exported.price_scenario = vehicle.price_scenario;
        var field;
        for (field in vehicle) {
            if (lockedInputs[field]) {
                /** @ts-ignore*/
                exported[field] = vehicle[field];
            }
        }
        return exported;
    };
    Facade.prototype.calculateInputs = function (vehicle, lockedInputs) {
        var _this = this;
        return this.createParameters(vehicle, lockedInputs)
            .then(function (params) { return _this.updateVehicleInput(vehicle, _this.createCalculator(params)); });
    };
    Facade.prototype.calculateResults = function (vehicleInput, lockedInputs) {
        var _this = this;
        return this.createParameters(vehicleInput, lockedInputs)
            .then(function (params) {
            var calculator = _this.createCalculator(params);
            return _this.createCo2OverHoldingPeriods(vehicleInput, lockedInputs)
                .then(function (resultCo2H) { return _this.createCo2OverMileages(vehicleInput, lockedInputs)
                .then(function (resultCo2M) { return _this.createTcoOverCo2Taxes(vehicleInput, lockedInputs)
                .then(function (tcoCo2) { return _this.createTcoOverHoldingPeriods(vehicleInput, lockedInputs)
                .then(function (tcoH) { return _this.createTcoOverMileages(vehicleInput, lockedInputs)
                .then(function (tcoM) {
                vehicleInput.CO2_by_mileage = resultCo2M;
                vehicleInput.CO2_by_holding_time = resultCo2H;
                vehicleInput.TCO_by_co2_price = tcoCo2;
                vehicleInput.TCO_by_holding_time = tcoH;
                vehicleInput.TCO_by_mileage = tcoM;
                vehicleInput.CO2 = Math.round(_this.calculateEmissions(calculator.params));
                vehicleInput.TCO = _this.createTco(calculator);
                vehicleInput.TCO_simplified = _this.createTcoSimple(calculator);
                vehicleInput.changed_fields = lockedInputs;
                return vehicleInput;
            }); }); }); }); });
        });
    };
    Facade.prototype.createTco = function (calculator) {
        return {
            total_cost: calculator.total.render(),
            purchase_costs: {
                net_list_price: calculator.params.listPrice.render(),
                residual_value: calculator.params.residualValue.render(),
                other_costs: calculator.otherPurchaseCosts.render(),
                funding: calculator.fundings.render(),
            },
            charging_infrastructure: calculator.chargingInfrastructure.render(),
            energy_costs: calculator.energy.render(),
            variable_costs: {
                operating_costs: calculator.lubricantsAndResources.render(),
                maintenance_costs: calculator.maintenance.render(),
                tire_costs: calculator.tires.render(),
            },
            fixed_costs: {
                insurance: calculator.insurance.render(),
                car_tax: calculator.vehicleTaxes.render(),
            },
        };
    };
    Facade.prototype.createTcoSimple = function (calculator) {
        return {
            charging_infrastructure: calculator.chargingInfrastructure.render(),
            energy_costs: calculator.energy.render(),
            fixed_costs: calculator.fixed.render(),
            net_cost: calculator.purchase().render(),
            variable_costs: calculator.repairAndMaintenance.render()
        };
    };
    Facade.prototype.createTcoOverHoldingPeriods = function (vehicle, lockedInputs) {
        var _this = this;
        var scenario = {
            x_values: [],
            contra: [],
            mittel: [],
            pro: []
        };
        return this.createParameters(vehicle, lockedInputs).then(function (parameters) {
            for (var period = 1; period <= 12; period++) {
                scenario.x_values.push(period);
                parameters.holdingPeriod = new Years(period);
                var calculator = _this.createCalculator(parameters);
                scenario.contra.push(calculator.totalContra.render());
                scenario.mittel.push(calculator.total.render());
                scenario.pro.push(calculator.totalPro.render());
            }
            return scenario;
        });
    };
    Facade.prototype.createTcoOverMileages = function (vehicle, lockedInputs) {
        var _this = this;
        var scenario = {
            x_values: [],
            contra: [],
            mittel: [],
            pro: []
        };
        return this.createParameters(vehicle, lockedInputs).then(function (parameters) {
            for (var mileage = 0; mileage <= 50000; mileage += 1000) {
                scenario.x_values.push(mileage);
                parameters.mileage = new AnnualMileage(mileage, MileageUnit.Kilometer);
                var calculator = _this.createCalculator(parameters);
                scenario.mittel.push(calculator.total.render());
                scenario.contra.push(calculator.totalContra.render());
                scenario.pro.push(calculator.totalPro.render());
            }
            return scenario;
        });
    };
    Facade.prototype.createTcoOverCo2Taxes = function (vehicle, lockedInputs) {
        var _this = this;
        var scenario = {
            x_values: [],
            contra: [],
            mittel: [],
            pro: []
        };
        return this.createParameters(vehicle, lockedInputs)
            .then(function (parameters) {
            for (var co2Tax = 35; co2Tax <= 440; co2Tax += 15) {
                scenario.x_values.push(co2Tax);
                parameters.co2TaxPriceStatic = Euro.create(co2Tax);
                var calculator = _this.createCalculator(parameters);
                scenario.contra.push(calculator.totalContra.render());
                scenario.mittel.push(calculator.total.render());
                scenario.pro.push(calculator.totalPro.render());
            }
            return scenario;
        });
    };
    Facade.prototype.createCo2OverHoldingPeriods = function (vehicle, lockedInputs) {
        var _this = this;
        var data = { x_values: [], y_values: [] };
        return this.createParameters(vehicle, lockedInputs).then(function (parameters) {
            for (var period = 0; period <= 12; period++) {
                parameters.holdingPeriod = new Years(period);
                data.x_values.push(period);
                data.y_values.push(_this.calculateEmissions(parameters));
            }
            return data;
        });
    };
    Facade.prototype.createCo2OverMileages = function (vehicle, lockedInputs) {
        var _this = this;
        var data = { x_values: [], y_values: [] };
        return this.createParameters(vehicle, lockedInputs).then(function (parameters) {
            for (var mileage = 0; mileage <= 50000; mileage += 1000) {
                parameters.mileage = new AnnualMileage(mileage, MileageUnit.Kilometer);
                data.x_values.push(mileage);
                data.y_values.push(_this.calculateEmissions(parameters));
            }
            return data;
        });
    };
    Facade.prototype.realUsageConsumption = function (parameters) {
        return new EnergyConsumption(parameters.realEnergyFactor).laboratoryToUsageSpecific(parameters.energyConsumption, parameters.roadUsageDistribution, parameters.roadTypeConsumption);
    };
    Facade.prototype.calculateEmissions = function (parameters) {
        var annualConsumption = parameters.mileage.annualMileage * this.realUsageConsumption(parameters) / 100;
        var emissions = 0;
        for (var _i = 0, _a = parameters.holdingPeriod.years(parameters.purchaseYear); _i < _a.length; _i++) {
            var year = _a[_i];
            var emissionFactor = void 0;
            var photovoltaik = 0;
            switch (parameters.driveType) {
                case DriveType.Diesel:
                    emissionFactor = 2.676284;
                    break;
                case DriveType.Petrol:
                    emissionFactor = 2.39422;
                    break;
                case DriveType.Electric:
                    emissionFactor = this.emissionFactorElectric(year, false);
                    photovoltaik = parameters.photovoltaik;
                    break;
                default:
                    throw new Error('emission factor is missing for ' + parameters.driveType);
            }
            emissions += (photovoltaik * 0.10885 + emissionFactor * (1 - photovoltaik)) * annualConsumption;
        }
        return Math.round(emissions / 100) / 10;
    };
    Facade.prototype.emissionFactorElectric = function (year, green) {
        var keyMix = green ? 1 : 0;
        var data = {
            "2024": [0.401, 0.09],
            "2025": [0.371, 0.089],
            "2026": [0.311, 0.086],
            "2027": [0.258, 0.085],
            "2028": [0.220, 0.083],
            "2029": [0.197, 0.082],
            "2030": [0.172, 0.08],
            "2031": [0.155, 0.078],
            "2032": [0.140, 0.078],
            "2033": [0.126, 0.077],
            "2034": [0.114, 0.076],
            "2035": [0.106, 0.075],
            "2036": [0.099, 0.075],
            "2037": [0.093, 0.075],
            "2038": [0.087, 0.074],
            "2039": [0.082, 0.074],
            "2040": [0.077, 0.074],
            "2041": [0.077, 0.074],
            "2042": [0.076, 0.074],
            "2043": [0.076, 0.074],
            "2044": [0.076, 0.073],
            "2045": [0.075, 0.073],
            "2046": [0.076, 0.073],
            "2047": [0.077, 0.073],
            "2048": [0.078, 0.073],
            "2049": [0.079, 0.073],
            "2050": [0.080, 0.072],
        };
        if (year < 2024) {
            return data["2024"][keyMix];
        }
        if (year > 2050) {
            return data[2050][keyMix];
        }
        var key = Math.round(year).toString();
        if (key in data) {
            return data[key][keyMix];
        }
        return 0;
    };
    Facade.prototype.vehicleService = function () {
        return new VehicleDataService(this.vehicleData, this.vehicleDetails);
    };
    return Facade;
}());

angular.module("oekoKostenrechner").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a ui-sref=\"main\" ng-hide=\"\'main\' | isState\" class=\"navbar__home\"><i class=\"fa fa-arrow-left\"></i> <span class=\"hidden-xs\">{{ \'home\' | translate }}</span></a></div><div><ul class=\"nav navbar-nav navbar-right navbar__languages\"><li ng-class=\"{ active: main.use() === \'en\' }\"><a ng-click=\"main.use(\'en\')\">English</a></li><li ng-class=\"{ active: main.use() === \'de\' }\"><a ng-click=\"main.use(\'de\')\">Deutsch</a></li></ul></div></div></nav>");
$templateCache.put("app/main/main.html","<div class=\"main\"><navbar></navbar><div ui-view=\"\"><div class=\"main__welcome-bg\"></div><div class=\"container\"><div class=\"main__welcome-screen\"><h2 class=\"main__welcome-screen__heading\">{{ \"welcome_title\" | translate }}</h2><div class=\"main__welcome-screen__body\"><p ng-bind-html=\"\'welcome_description_4\' | translate\" class=\"lead\"></p></div><p class=\"main__welcome-screen__footer\"><button ui-sref=\"main.form\" type=\"button\" class=\"btn btn-default btn-md\"><i class=\"fa fa-car fa-fw\"></i>&nbsp{{ \"start_btn_privat\" | translate }}</button></p><div class=\"main__welcome-screen__body\"><p ng-bind-html=\"\'welcome_example_description\' | translate\" class=\"lead\"></p><p class=\"main__welcome-screen__footer\"><button type=\"button\" ng-click=\"main.addDefault(\'petrol\', \'kompakt\')\" class=\"btn btn-default btn-md\"><i class=\"fa fa-car fa-fw\"></i><span>{{ \"example_compact_petrol\" | translate }}</span></button> <button type=\"button\" ng-click=\"main.addDefault(\'petrol\', \'mittel\')\" class=\"btn btn-default btn-md\"><i class=\"fa fa-car fa-fw\"></i><span>{{ \"example_middle_diesel\" | translate }}</span></button></p></div></div><span class=\"main__image-credits\">© iStock/100pk</span></div></div><div class=\"main__\"></div><div ng-show=\"(\'main.form.*\' | includedByState) &amp;&amp; main.vehicles.length || (\'main.chart.*\' | includedByState)\" class=\"main__vehicles\"><div ng-show=\"main.showTour\" class=\"main__vehicles__tour\"><div class=\"main__vehicles__tour__header\"><div ng-click=\"main.showTour = false\" class=\"close-btn\"><i class=\"fa fa-close\"></i></div></div><div class=\"main__vehicles__tour__explainer-vehicles\"><i class=\"fa fa-arrow-down\"></i><span>{{ \'vehicle_help\' | translate }}</span></div></div><div class=\"main__vehicles__wrapper\"><div ng-repeat=\"vehicle in main.vehicles | limitTo:2\" ng-click=\"main.openVehicle(vehicle, $index)\" ng-attr-style=\"background: {{ vehicle.color }}\" class=\"main__vehicles__wrapper__item\"><div class=\"main__vehicles__wrapper__item__overlay\"><i class=\"fa fa-eye\"></i></div><div class=\"main__vehicles__wrapper__item__heading\"><div ng-attr-style=\"border-color: {{ vehicle.color }}\" class=\"main__vehicles__wrapper__item__heading__printable-color\"></div><div class=\"main__vehicles__wrapper__item__heading__actions\"><button ng-click=\"main.removeVehicle($index)\" class=\"btn btn-xs btn-link\"><i class=\"fa fa-trash\"></i><span class=\"sr-only\">{{ \"remove_btn\" | translate }}</span></button></div><span ng-bind-html=\"\'vehicle_name\' | translate:main.getVehicleOpts(vehicle)\"></span></div><table class=\"table table-condensed table-striped main__vehicles__wrapper__item__body\"><tbody><tr ng-repeat=\"setting in main.listedSettings | orderBy:\'importancerank\' | filter:main.filterSetting(vehicle) | limitTo:5\"><td>{{ setting.label | translate }}</td><td><strong ng-if=\"!(setting.interval &lt; 1 &amp;&amp; setting.interval &gt; 0)\">{{ vehicle[setting.name] | translate }}</strong><strong ng-if=\"setting.interval &lt; 1 &amp;&amp; setting.interval &gt; 0\">{{ vehicle[setting.name] | number:2 }}</strong><span>&nbsp;{{ setting.unit | translate }}</span></td></tr></tbody></table></div><a ng-show=\"(\'main.chart.*\' | includedByState) &amp;&amp; main.vehicles.length &lt; 2\" ui-sref=\"main.form\" class=\"main__vehicles__wrapper__add-item\"><i class=\"fa fa-plus\"></i><span><br class=\"hidden-xs\">{{ \"add_vehicle_btn\" | translate }}</span></a></div></div></div>");
$templateCache.put("app/main/chart/chart.html","<div class=\"main__chart\"><ul role=\"navigation\" class=\"main__chart__nav nav nav-pills\"><li ui-sref-active=\"active\"><a ui-sref=\"main.chart.tco({ type: \'bar\' })\">{{ \"tco_sharing_btn\" | translate }}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"main.chart.tco({ type: \'spline\' })\">{{ \"tco_trend_btn\" | translate }}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"main.chart.co2({ type: \'spline\' })\" ng-bind-html=\"\'co2_btn\' | translate\"></a></li><li ui-sref-active=\"active\"><a ui-sref=\"main.chart.table\" ng-bind-html=\"\'table_btn\' | translate\"></a></li></ul><h2 class=\"main__chart__heading\">{{ \"tco_title\" | translate }}</h2><div role=\"alert\" ng-if=\"main.survey.group\" class=\"alert teaser-survey alert-info\"><p>Wenn Sie mit dem Online-Rechner fertig sind, also z.B. die Fahrzeuge an Ihre eigenen Bedürfnisse angepasst haben und sich</p>die verschiedenen Ergebnisdarstellungen angesehen haben, gelangen Sie über einen weiter unten platzierten Link zurück zu Ihrem Fragebogen der Otto-von-Guericke-Universität Magdeburg.</div><div class=\"main__chart__view main__chart__view--{{ chart.type }}\"><div ui-view=\"\"></div><div ng-if=\"!(\'main.chart.table\' | isState)\"><div class=\"main__chart__view__workspace\"><chart x=\"chart.xAxis\" y=\"chart.yAxis\" type=\"chart.type\" vehicles=\"main.vehicles\" processor=\"main.processor\"></chart></div><div ng-hide=\"chart.type === \'bar\'\" class=\"row main__chart__view__options slide\"><div class=\"col-xs-12\"><label>{{ \'horizontal_axis\' | translate }}</label><select ng-options=\"opt.name as (opt.label | translate) for opt in chart.xAxisOptions\" ng-model=\"chart.xAxis\" ng-disabled=\"chart.type === \'bar\'\" class=\"form-control\"></select></div></div><div translate=\"\" class=\"main__chart__view__explainer\">{{ chart.getExplainer() }}</div></div></div><a ng-click=\"chart.print()\" class=\"main__chart__print\"><i class=\"fa fa-print fa-3x\"></i><span class=\"sr-only\">{{ \"print\" | translate }}</span></a> <label class=\"main__chart__share\">{{ \"link_to_visualization\" | translate }} <input type=\"text\" select-on-click=\"\" readonly=\"\" ng-value=\"chart.permalink\" class=\"form-control\"></label><div ng-if=\"main.survey.group\" class=\"main__chart__survey-continue\"><a href=\"{{main.surveyUrl}}\" target=\"_blank\" class=\"btn btn-block btn-warning\"><strong>Hier gelangen Sie zur Nachbefragung</strong><i class=\"fa fa-arrow-right fa-fw\"></i></a></div></div>");
$templateCache.put("app/main/form/form.html","<div class=\"main__form\"><div ng-repeat=\"step in form.getSteps() | filter:form.isStepActive track by step.id\" class=\"main__form__step\"><form ng-submit=\"form.nextStep()\" name=\"stepForm\" novalidate=\"\"><h2 class=\"main__form__step__heading\"><span ng-show=\"!!step.label_long\">{{ step.label_long | translate }}</span><span ng-show=\"!step.label_long\">{{ step.label | translate }}</span></h2><div class=\"main__form__step__position\">{{ \'step_position\' | translate:{ current: form.getActiveStepIdx() + 1, total: form.getStepsCount() } }}</div><div ng-switch=\"\" on=\":: form.getStepType(step)\"><div ng-switch-when=\"enum|enum_dynamic\" ng-switch-when-separator=\"|\"><p class=\"main__form__step__body main__form__step__body--select\"><label ng-repeat=\"value in form.getStepValues(step).range track by $index\" ng-class=\"{ \'active\': form.newVehicle[step.name] === value }\" class=\"main__form__step__body__radio radio\"><input type=\"radio\" required=\"\" name=\"{{ step.name }}\" ng-value=\"value\" ng-model=\"form.newVehicle[step.name]\"><span>{{ value | translate }}</span><span uib-tooltip=\"{{ value + \'-tooltip\' | translate }}\" ng-show=\"form.inputs[step.id].setting.hashelp\" class=\"text-muted small main__form__step__body__radio__help\"><i class=\"fa fa-info\"></i></span></label></p></div><div ng-switch-when=\"interval\"><div ng-if=\":: !form.inputs[step.id].setting.hasslider\"><p class=\"main__form__step__body main__form__step__body--select\"><label ng-repeat=\"value in form.getStepValues(step).range track by $index\" ng-class=\"{ \'active\': form.newVehicle[step.name] === value }\" class=\"main__form__step__body__radio radio\"><input type=\"radio\" required=\"\" name=\"{{ step.name }}\" ng-value=\"value\" ng-model=\"form.newVehicle[step.name]\"><span>{{ value | translate }}</span><span uib-tooltip=\"{{ value + \'-tooltip\' | translate }}\" ng-show=\"form.inputs[step.id].setting.hashelp\" class=\"text-muted small main__form__step__body__radio__help\"><i class=\"fa fa-info\"></i></span></label></p></div><div ng-if=\":: form.inputs[step.id].setting.hasslider\"><div ng-init=\"form.newVehicle[step.name] = form.getStepValues(step).value\"><p class=\"main__form__step__body main__form__step__body--slider\"><rzslider rz-slider-model=\"form.newVehicle[step.name]\" rz-slider-options=\"form.getStepValues(step)\"></rzslider></p></div></div></div></div><p ng-bind-html=\"step.privatdesc | translate\" class=\"main__form__step__description\"></p><p class=\"main__form__step__nav\"><a ng-click=\"form.previousStep()\" class=\"btn btn-link btn-lg\">{{ \'go_back\' | translate }}</a> <button type=\"submit\" ng-disabled=\"stepForm.$invalid\" class=\"btn btn-primary btn-lg\">{{ \'next_step\' | translate }}</button></p></form></div></div>");
$templateCache.put("app/main/page/page.html","<div class=\"main__page\"><div btf-markdown=\"page.content\" class=\"main__page__content\"></div></div>");
$templateCache.put("app/main/vehicle/vehicle.html","<form ng-submit=\"modal.saveVehicle()\" name=\"vehicleForm\" novalidate=\"\" class=\"main__vehicle\"><div ng-style=\"{ background: modal.vehicle.color }\" class=\"modal-header main__vehicle__heading\"><h3 class=\"modal-title\"></h3>{{ \"vehicle_name_striped\" | translate:{ energy_type:(modal.vehicle.energy_type|translate), car_type:(modal.vehicle.car_type|translate) } }}</div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"modal.close()\" class=\"btn btn-default btn-lg pull-left\">{{ \'cancel_modal\' | translate }}</button> <button type=\"submit\" ng-disabled=\"vehicleForm.$invalid\" class=\"btn btn-primary btn-lg\">{{ \'save_modal\' | translate }}</button></div><div ng-repeat=\"group in modal.groups | orderBy:\'importancerank\' | filter:modal.isGroupVisible\" class=\"main__vehicle__group\"><div class=\"modal-body\"><h4 class=\"main__vehicle__group__title\">{{ group.name | translate }}</h4></div><table class=\"table table-striped main__vehicle__group__table\"><tbody><tr ng-repeat=\"setting in group.settings | orderBy:\'importancerank\' | filter:modal.isSettingVisible\" ng-class=\"{ warning: setting.context === \'presets\' }\"><td style=\"width: 60%\">{{ setting.label | translate }}<span uib-tooltip-html=\"setting.privatdesc | translate\" ng-show=\"setting.privatdesc\" class=\"small main__vehicle__group__table__info\"><i class=\"fa fa-info\"></i></span></td><td style=\"width: 40%\"><div ng-repeat=\"context in modal.contexts\"><div ng-switch=\"\" on=\":: modal.inputs[setting.id].getType()\" ng-if=\"setting.context === context\"><div ng-switch-when=\"boolean\"><input type=\"checkbox\" ng-model=\"modal.gs(context, setting.name, setting.id)\" ng-model-options=\"{ getterSetter: true }\"></div><div ng-switch-when=\"enum|enum_dynamic\" ng-switch-when-separator=\"|\" ng-class=\"{ \'input-group\': setting.unit }\"><select ng-options=\"val as (val | translate) for val in modal.values[setting.id].range\" ng-model=\"modal.gs(context, setting.name, setting.id)\" ng-model-options=\"{ getterSetter: true }\" class=\"form-control\"></select><span ng-show=\"setting.unit\" class=\"input-group-addon\">{{ setting.unit | translate }}</span></div><div ng-switch-when=\"interval\" ng-class=\"{ \'input-group\': setting.unit }\"><input type=\"number\" min=\"{{ modal.values[setting.id].floor }}\" max=\"{{ modal.values[setting.id].ceil }}\" step=\"{{ modal.values[setting.id].step != 1 ? modal.values[setting.id].step : \'any\' }}\" ng-model=\"modal.gs(context, setting.name, setting.id)\" ng-model-options=\"{ getterSetter: true, updateOn: \'blur click\' }\" class=\"form-control\"><span ng-show=\"setting.unit\" class=\"input-group-addon\">{{ setting.unit | translate }}</span></div><div ng-switch-default=\"\"><strong>{{ modal[context][setting.name] | number:precision(setting.interval) }}</strong><span>&nbsp;{{ setting.unit | translate }}</span></div></div></div></td></tr></tbody></table></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"modal.close()\" class=\"btn btn-default btn-lg pull-left\">{{ \'cancel_modal\' | translate }}</button> <button type=\"submit\" ng-disabled=\"vehicleForm.$invalid\" class=\"btn btn-primary btn-lg\">{{ \'save_modal\' | translate }}</button></div></form>");
$templateCache.put("app/main/chart/table/table.html","<div class=\"main__chart__view__table\"><table class=\"table table-striped\"><thead><tr><th translate=\"\">totals</th><th ng-repeat=\"vehicle in main.vehicles\" style=\"width: 35%\"><i class=\"fa fa-car\"></i><span>&nbsp;</span><span ng-bind-html=\"\'vehicle_name\' | translate:main.getVehicleOpts(vehicle)\"></span></th></tr></thead><tbody><tr><td translate=\"\">tco_table</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.total_cost) }}€</td></tr><tr><td translate=\"\">co2_title</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.CO2) }}t CO₂</td></tr></tbody></table><table class=\"table table-striped\"><thead><tr><th translate=\"\">details</th><th ng-repeat=\"vehicle in main.vehicles\" style=\"width: 35%\"><i class=\"fa fa-car\"></i><span>&nbsp;</span><span ng-bind-html=\"\'vehicle_name\' | translate:main.getVehicleOpts(vehicle)\"></span></th></tr></thead><tbody><tr><td translate=\"\">net_list_price</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.purchase_costs.net_list_price) }}€</td></tr><tr><td translate=\"\">residual_value</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(-vehicle.TCO.purchase_costs.residual_value) }}€</td></tr><tr><td translate=\"\">funding</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.purchase_costs.funding) }}€</td></tr><tr><td translate=\"\">other_costs</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.purchase_costs.other_costs) }}€</td></tr><tr><td translate=\"\">charging_infrastructure</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.charging_infrastructure) }}€</td></tr><tr><td translate=\"\">energy_costs</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.energy_costs) }}€</td></tr><tr><td translate=\"\">operating_costs</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.variable_costs.operating_costs) }}€</td></tr><tr><td translate=\"\">maintenance_costs</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.variable_costs.maintenance_costs) }}€</td></tr><tr><td translate=\"\">insurance</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.fixed_costs.insurance) }}€</td></tr><tr><td translate=\"\">car_tax</td><td ng-repeat=\"vehicle in main.vehicles\">{{ table.number(vehicle.TCO.fixed_costs.car_tax) }}€</td></tr></tbody></table></div>");}]);